import _parseInt from '@babel/runtime-corejs3/core-js-stable/parse-int';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import { customProperties } from '@commercetools-uikit/design-system';
import _extends from '@babel/runtime-corejs3/helpers/esm/extends';
import _styled from '@emotion/styled/base';
import _findInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import React, { useCallback } from 'react';
import reactIs from 'react-is';
import { jsx, ThemeProvider, useTheme, css, Global } from '@emotion/react';
import _slicedToArray from '@babel/runtime-corejs3/helpers/esm/slicedToArray';
import _pt from 'prop-types';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import SpacingsInline from '@commercetools-uikit/spacings-inline';
import _WeakMap from '@babel/runtime-corejs3/core-js-stable/weak-map';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$create from '@babel/runtime-corejs3/core-js-stable/object/create';
import _Symbol$replace from '@babel/runtime-corejs3/core-js-stable/symbol/replace';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _Symbol from '@babel/runtime-corejs3/core-js-stable/symbol';
import _getIteratorMethod from '@babel/runtime-corejs3/core-js/get-iterator-method';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _inherits from '@babel/runtime-corejs3/helpers/esm/inherits';
import _setPrototypeOf from '@babel/runtime-corejs3/helpers/esm/setPrototypeOf';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _trimInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/trim';
import _Array$from from '@babel/runtime-corejs3/core-js-stable/array/from';
import _matchAllInstanceProperty from '@babel/runtime-corejs3/core-js/instance/match-all';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import _setTimeout from '@babel/runtime-corejs3/core-js-stable/set-timeout';
import _someInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/some';
import ReactDOM from 'react-dom';
import Tooltip from '@commercetools-uikit/tooltip';
import { ClipboardIcon, InformationIcon, ErrorIcon, WarningIcon } from '@commercetools-uikit/icons';
import Highlight, { defaultProps } from 'prism-react-renderer';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/esm/toConsumableArray';
import nightOwl from 'prism-react-renderer/themes/nightOwl';
import nightOwlLight from 'prism-react-renderer/themes/nightOwlLight';
import _asyncToGenerator from '@babel/runtime-corejs3/helpers/esm/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import _Promise from '@babel/runtime-corejs3/core-js-stable/promise';
import _sortInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/sort';
import _flatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/flat';
import useSWR from 'swr';
import LoadingSpinner from '@commercetools-uikit/loading-spinner';
import invariant from 'tiny-invariant';
import { useIntl } from 'react-intl';
var rootFontSizeNumber = 16;
var pageWidth = '770px';
var pageWidthSmall = '592px';
var asideColumnWidth = pageWidthSmall;
var navbarWidth = '224px';
var navbarWidthSmall = '200px';

var pxToRem = function pxToRem(px) {
  var _context;

  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rem';
  var pxNumber = px.replace(/([0-9]+)px$/, '$1');
  var remNumber = _parseInt(pxNumber, 10) / rootFontSizeNumber;
  return _concatInstanceProperty(_context = "".concat(remNumber)).call(_context, suffix);
};

var colors = {
  light: {
    // Surfaces are used for backgrounds
    surfacePrimary: customProperties.colorSurface,
    surfaceSecondary1: customProperties.colorNeutral95,
    surfaceSecondary2: customProperties.colorNeutral90,
    surfaceSecondary3: customProperties.colorNeutral60,
    surfaceInlineCode: customProperties.colorNeutral95,
    surfaceCode: customProperties.colorAccent,
    surfaceCodeCopy: customProperties.colorAccent30,
    surfaceCodeHighlight: customProperties.colorAccent40,
    surfaceInfo: customProperties.colorInfo95,
    surfaceBeta: customProperties.colorInfo85,
    surfaceQuote: customProperties.colorAccent98,
    surfaceWarning: customProperties.colorWarning95,
    surfaceError: customProperties.colorError95,
    surfaceSearchHighlight: customProperties.colorAccent95,
    surfaceForSearchInputWhenDisabled: customProperties.colorNeutral90,
    surfaceForReleaseNoteTypeFix: '#e4c5ff',
    // Different tones of text
    textPrimary: customProperties.colorSolid,
    textSecondary: '#666666',
    textFaded: customProperties.colorNeutral60,
    textCode: customProperties.colorError,
    textInfo: customProperties.colorInfo,
    textError: customProperties.colorError,
    textWarning: customProperties.colorWarning,
    textInverted: customProperties.colorSurface,
    textSearchHeading: customProperties.colorPrimary25,
    // Different tones of border colors
    borderPrimary: customProperties.colorNeutral90,
    borderSecondary: customProperties.colorNeutral,
    borderInput: customProperties.colorNeutral60,
    borderHighlight: customProperties.colorPrimary,
    borderInfo: customProperties.colorInfo,
    borderForReleaseNoteTypeFix: '#b866ff',
    // Links
    link: customProperties.colorPrimary25,
    linkHover: customProperties.colorPrimary,
    linkNavigation: customProperties.colorInfo,
    // Code blocks
    // We support 2 theme versions: a primary one and a secondary one.
    // This is not to be confused with a (potential) website theme, hence
    // the 2 versions being grouped together.
    // The code block theme is controlled by a prop, which will use the
    // emotion theming provider to inject the correct version of a theme.
    //
    //   <ThemeProvider
    //     theme={{
    //       codeBlockColors: colors.light.codeBlocks[props.secondaryTheme ? 'secondary' : 'primary'],
    //     }}
    //   >
    //
    // Do not use these properties directly, but always through an emotion theme provider.
    codeBlocks: {
      primary: {
        border: customProperties.colorAccent40,
        surface: customProperties.colorAccent,
        surfaceHeader: customProperties.colorSolid,
        surfaceLanguageDropdown: customProperties.colorSurface,
        surfaceLanguageDropdownHover: customProperties.colorNeutral90,
        textHeader: customProperties.colorNeutral60,
        surfaceCopyIcon: customProperties.colorSurface,
        surfaceCopyIconHover: customProperties.colorAccent40,
        surfaceCopyTooltip: customProperties.colorAccent40,
        textCopyTooltip: customProperties.colorSurface,
        surfaceLineHighlight: customProperties.colorAccent40,
        surfacePrompt: customProperties.colorNeutral60
      },
      secondary: {
        border: customProperties.colorNeutral90,
        surface: customProperties.colorSurface,
        surfaceHeader: customProperties.colorNeutral,
        surfaceLanguageDropdown: customProperties.colorSolid,
        surfaceLanguageDropdownHover: customProperties.colorNeutral60,
        textHeader: customProperties.colorSolid,
        surfaceCopyIcon: customProperties.colorSolid,
        surfaceCopyIconHover: customProperties.colorAccent40,
        surfaceCopyTooltip: customProperties.colorAccent40,
        textCopyTooltip: customProperties.colorSurface,
        surfaceLineHighlight: customProperties.colorNeutral90,
        surfacePrompt: customProperties.colorNeutral60
      }
    }
  }
};
var tokens = {
  borderRadiusForBetaFlag: customProperties.borderRadius4,
  borderRadiusForSearchDialog: customProperties.borderRadius6,
  borderRadiusForSearchInput: customProperties.borderRadius6,
  borderRadiusForCodeBlock: customProperties.borderRadius6,
  borderRadiusForTooltip: customProperties.borderRadius4,
  borderRadiusForContentNotification: customProperties.borderRadius6,
  borderRadiusForImageFrame: customProperties.borderRadius6,
  borderRadiusForBlockquote: customProperties.borderRadius6,
  borderRadiusForCard: customProperties.borderRadius6,
  borderRadiusForChildSectionNav: customProperties.borderRadius6,
  borderRadiusForRssFeedTable: customProperties.borderRadius6,
  shadowForBetaFlag: customProperties.shadow7,
  shadowForSearchDialog: customProperties.shadow2,
  shadowForPageContent: customProperties.shadow11,
  shadowForClickableCard: "1px 1px 4px 0 rgba(0, 0, 0, 0.24),\n  -1px 1px 3px 0 rgba(0, 0, 0, 0.12)",
  shadowForClickableCardOnHover: "0 14px 28px 0 rgba(0, 0, 0, 0.25),\n  0 10px 10px 0 rgba(0, 0, 0, 0.23)",
  shadowForRssFeedTable: customProperties.shadow7
};
var dimensions = {
  heights: {
    header: '48px',
    inputSearchPrimary: '32px',
    inputSearchSecondary: '26px',
    childSectionNavLink: '28px',
    pageSearchboxSpace: '58px',
    globalNotificationContent: '36px'
  },
  widths: {
    pageContent: pageWidth,
    pageContentSmall: pageWidthSmall,
    pageContentWide: "calc(".concat(pageWidth, " + ").concat(asideColumnWidth, " + 32px)"),
    pageContentWithMargins: "calc(".concat(pageWidth, " + 32px * 2)"),
    pageContentSmallWithMargins: "calc(".concat(pageWidthSmall, " + 16px * 2)"),
    pageContentWideWithMargins: "calc(".concat(pageWidthSmall, " + ").concat(asideColumnWidth, " + 32px * 3)"),
    pageContentWideWithMarginsMax: "calc(".concat(pageWidth, " + ").concat(asideColumnWidth, " + 32px * 3)"),
    pageContentWithMarginsAndPageNavigation: "calc(".concat(pageWidth, " + 32px * 2 + ").concat(navbarWidth, ")"),
    pageNavigation: navbarWidth,
    pageNavigationSmall: navbarWidthSmall,
    marketingContent: '1168px',
    searchBar: '300px',
    searchBarSmall: '160px',
    selectDropDownArrowWith: '12px',
    sideBySideSecondColumn: '560px'
  },
  viewports: {
    mobile: "max-width: calc(768px - 0.02px)",
    tablet: "min-width: calc(768px - 0.01px)",
    largeTablet: "min-width: calc(848px - 0.01px)",
    laptop: "min-width: calc(1024px - 0.01px)",
    desktop: "min-width: calc(1280px - 0.01px)",
    largeDesktop: "min-width: calc(1706px - 0.01px)"
  },
  spacings: {
    xs: pxToRem('4px'),
    s: pxToRem('8px'),
    m: pxToRem('16px'),
    l: pxToRem('24px'),
    xl: pxToRem('32px'),
    xxl: pxToRem('40px'),
    big: pxToRem('48px'),
    large: pxToRem('56px'),
    wide: pxToRem('64px'),
    enormous: pxToRem('72px'),
    huge: pxToRem('80px')
  },
  stacks: {
    base: 1,
    sidebar: 2,
    overlay: 20,
    aboveOverlay: 21
  }
};
var typography = {
  fontFamilies: {
    primary: "'Roboto', sans-serif",
    code: "'Roboto Mono', monospace"
  },
  rootFontSize: "".concat(rootFontSizeNumber, "px"),
  fontSizes: {
    h1: pxToRem('48px'),
    h2: pxToRem('26px'),
    h3: pxToRem('24px'),
    h4: pxToRem('20px'),
    h5: pxToRem('16px'),
    h6: pxToRem('16px'),
    body: pxToRem('16px'),
    small: pxToRem('14px'),
    // The sizes below are only used in specific case. Do not use them regularly.
    // If necessary, ask the Design team.
    extraSmall: pxToRem('12px'),
    ultraSmall: pxToRem('10px')
  },
  relativeFontSizes: {
    ultraSmall: pxToRem('10px', 'em')
  },
  fontWeights: {
    regular: '400',
    medium: '500',
    bold: '700'
  },
  lineHeights: {
    small: pxToRem('16px'),
    body: pxToRem('23px'),
    releaseNoteHeader: pxToRem('28px'),
    cardNormalTitle: pxToRem('32px'),
    cardSmallTitle: pxToRem('26px')
  }
};
var uikitTheme = {
  fontFamilyDefault: typography.fontFamilies.primary,
  fontFamilyBody: typography.fontFamilies.primary
};
var designSystem = /*#__PURE__*/Object.freeze({
  __proto__: null,
  pxToRem: pxToRem,
  colors: colors,
  tokens: tokens,
  dimensions: dimensions,
  typography: typography,
  uikitTheme: uikitTheme
});

var SvgCustomApplicationSmall = function SvgCustomApplicationSmall(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 25 25",
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "#044E7C"
  }, jsx("path", {
    d: "M12.679 13.234c-.1 0-.1 0-.2-.1l-5.1-2.9c-.1-.1-.2-.2-.2-.3v-6.1c0-.1.1-.3.2-.3.1-.1.3-.1.4 0l5.1 2.9c.1.1.2.2.2.3v6.2c0 .1-.1.3-.2.3h-.2zm-4.7-3.5 4.3 2.5v-5.3l-4.3-2.5v5.3z"
  }), jsx("path", {
    d: "m12.879 13.234-.4-.7 4.9-2.8v-5.2l-4.5 2.6-.4-.7 5.1-2.9c.1-.1.3-.1.4 0 .1.1.2.2.2.3v6.2c0 .1-.1.3-.2.3l-5.1 2.9z"
  }), jsx("path", {
    d: "m17.579 4.134-4.9-2.8-4.9 2.8-.4-.7 5.1-2.9c.1-.1.3-.1.4 0l5.1 2.9-.4.7zm-11.1 20.4c-.1 0-.1 0-.2-.1l-5.1-2.9c-.1-.1-.2-.2-.2-.3v-6.2c0-.1.1-.3.2-.3.1-.1.3-.1.4 0l5.1 2.9c.1.1.2.2.2.3v6.2c0 .1-.1.3-.2.3 0 .1-.1.1-.2.1zm-4.7-3.5 4.3 2.5v-5.3l-4.3-2.5v5.3z"
  }), jsx("path", {
    d: "m6.679 24.434-.4-.7 4.9-2.8v-5.3l-4.5 2.6-.4-.7 5.1-2.9c.1-.1.3-.1.4 0 .1.1.2.2.2.3v6.2c0 .1-.1.3-.2.3l-5.1 3z"
  }), jsx("path", {
    d: "m11.379 15.434-4.9-2.8-4.9 2.8-.4-.7 5.1-2.9c.1-.1.3-.1.4 0l5.1 2.9-.4.7zm7.5 9.1c-.1 0-.1 0-.2-.1l-5.1-2.9c-.1-.1-.2-.2-.2-.3v-6.2c0-.1.1-.3.2-.3.1-.1.3-.1.4 0l5.1 2.9c.1.1.2.2.2.3v6.2c0 .1-.1.3-.2.3-.1.1-.2.1-.2.1zm-4.7-3.5 4.3 2.5v-5.3l-4.3-2.5v5.3z"
  }), jsx("path", {
    d: "m19.079 24.434-.4-.7 4.9-2.8v-5.3l-4.5 2.6-.4-.7 5.1-2.9c.1-.1.3-.1.4 0 .1.1.2.2.2.3v6.2c0 .1-.1.3-.2.3l-5.1 3z"
  }), jsx("path", {
    d: "m13.979 15.434-.4-.7 5.1-2.9c.1-.1.3-.1.4 0l5.1 2.9-.4.7-4.9-2.8-4.9 2.8z"
  })));
};

var SvgCustomApplication = function SvgCustomApplication(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 80 80",
    width: 80,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "#044E7C"
  }, jsx("path", {
    d: "M22.613 11.883v19.9c0 .448.24.862.629 1.085l16.4 9.4a1.25 1.25 0 0 0 1.871-1.085v-19.9c0-.448-.24-.862-.628-1.084l-16.4-9.4a1.25 1.25 0 0 0-1.872 1.084zm2.5 2.157 13.9 7.967v17.019l-13.9-7.967V14.04z"
  }), jsx("path", {
    d: "M56.042 10.799a1.25 1.25 0 0 1 1.866.96l.005.124v19.9c0 .403-.194.779-.516 1.012l-.112.073-16.4 9.4-1.243-2.17 15.771-9.04V14.039l-14.528 8.329-1.243-2.17 16.4-9.4z"
  }), jsx("path", {
    d: "M39.647 1.496a1.25 1.25 0 0 1 1.103-.064l.13.064 16.4 9.3-1.233 2.174-15.784-8.95-15.783 8.95-1.233-2.174 16.4-9.3zM2.713 48.183v19.9c0 .45.242.865.634 1.087l16.4 9.3a1.25 1.25 0 0 0 1.866-1.087v-19.9c0-.45-.242-.865-.633-1.087l-16.4-9.3a1.25 1.25 0 0 0-1.867 1.087zm2.5 2.146 13.9 7.882v17.026l-13.9-7.882V50.329z"
  }), jsx("path", {
    d: "M36.147 47.096a1.25 1.25 0 0 1 1.86.964l.006.123v19.9c0 .405-.196.782-.52 1.015l-.113.072-16.4 9.3-1.233-2.174 15.766-8.942V50.328L20.98 58.57l-1.233-2.174 16.4-9.3z"
  }), jsx("path", {
    d: "M19.742 37.699a1.25 1.25 0 0 1 1.112-.066l.13.066 16.4 9.4-1.242 2.169-15.779-9.045-15.778 9.045-1.243-2.17 16.4-9.4zm22.771 10.484v19.9c0 .45.242.865.634 1.087l16.4 9.3a1.25 1.25 0 0 0 1.866-1.087v-19.9c0-.45-.242-.865-.633-1.087l-16.4-9.3a1.25 1.25 0 0 0-1.867 1.087zm2.5 2.146 13.9 7.882v17.026l-13.9-7.882V50.329z"
  }), jsx("path", {
    d: "M75.947 47.096a1.25 1.25 0 0 1 1.86.964l.006.123v19.9c0 .405-.196.782-.52 1.015l-.113.072-16.4 9.3-1.233-2.174 15.766-8.942V50.328L60.78 58.57l-1.233-2.174 16.4-9.3z"
  }), jsx("path", {
    d: "M59.542 37.699a1.25 1.25 0 0 1 1.112-.066l.13.066 16.4 9.4-1.242 2.169-15.779-9.045-15.778 9.045-1.243-2.17 16.4-9.4zm2.921-8.366a2.45 2.45 0 1 0 0 4.9 2.45 2.45 0 0 0 0-4.9zm-44.4 0a2.45 2.45 0 1 0 0 4.9 2.45 2.45 0 0 0 0-4.9zm22.2 41a2.45 2.45 0 1 0 0 4.9 2.45 2.45 0 0 0 0-4.9z"
  })));
};

var SvgHttpApiSmall = function SvgHttpApiSmall(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 25 25",
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "none"
  }, jsx("path", {
    d: "M12.422 23.91c-.1 0-.1 0-.2-.1l-11.4-7.4c-.1-.1-.2-.2-.2-.3 0-.1.1-.3.2-.3l2.5-1.6.4.7-2 1.3 10.7 6.9 10.7-6.9-2-1.3.4-.7 2.6 1.7c.1.1.2.2.2.3 0 .1-.1.3-.2.3l-11.4 7.4h-.3z",
    fill: "#078CDF"
  }), jsx("path", {
    d: "M12.422 20.61c-.1 0-.1 0-.2-.1l-11.4-7.4c-.1-.1-.2-.2-.2-.3 0-.1.1-.3.2-.3l2.6-1.7.4.7-2.1 1.3 10.7 6.9 10.7-6.9-2.1-1.3.4-.7 2.6 1.7c.1.1.2.2.2.3 0 .1-.1.3-.2.3l-11.4 7.4c-.1.1-.1.1-.2.1z",
    fill: "#078CDF"
  }), jsx("path", {
    d: "M12.422 17.31c-.1 0-.1 0-.2-.1l-11.4-7.4c-.1-.1-.2-.2-.2-.3 0-.1.1-.3.2-.3l2.7-1.7c.2-.1.4-.1.5.1.1.2.1.4-.1.5l-2.2 1.4 10.7 6.9 10.7-6.9-2.3-1.5c-.2-.1-.2-.4-.1-.5.1-.2.4-.2.5-.1l2.8 1.8c.1.1.2.2.2.3 0 .1-.1.3-.2.3l-11.4 7.4c-.1 0-.1.1-.2.1z",
    fill: "#078CDF"
  }), jsx("path", {
    d: "M10.216 10.816H8.69l-.254-1.76H6.574l-.255 1.76H4.922L6.457 1.11h2.224l1.535 9.706zM6.764 7.733h1.461l-.73-4.906-.73 4.906zm9.628-4.223v1.258c0 1.557-.73 2.4-2.221 2.4h-.699v3.648h-1.491V1.11h2.19c1.491 0 2.221.842 2.221 2.4zm-2.92-1.014v3.285h.699c.48 0 .73-.224.73-.917v-1.45c0-.694-.25-.918-.73-.918h-.699zm4.685-1.386h1.765v9.706h-1.765z",
    fill: "#044E7C"
  })));
};

var SvgHttpApi = function SvgHttpApi(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 80 80",
    width: 80,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "none"
  }, jsx("path", {
    d: "m69.079 45.35 8.2 5.3a1.25 1.25 0 0 1 .112 2.018l-.114.083-36.3 23.4a1.25 1.25 0 0 1-1.227.071l-.127-.071-36.3-23.4a1.25 1.25 0 0 1-.118-2.016l.114-.083 8-5.2 1.362 2.096L6.3 51.695l34 21.917 33.995-21.914-6.574-4.248 1.358-2.1z",
    fill: "#078CDF"
  }), jsx("path", {
    d: "m69.07 34.844 8.2 5.2a1.25 1.25 0 0 1 .122 2.024l-.115.083-36.3 23.4a1.25 1.25 0 0 1-1.227.071l-.127-.071-36.3-23.4a1.25 1.25 0 0 1-.108-2.024l.116-.083 8.2-5.2 1.338 2.112-6.549 4.152L40.3 63.012l33.979-21.904-6.548-4.152 1.338-2.112z",
    fill: "#078CDF"
  }), jsx("path", {
    d: "M66.647 24.226a1.25 1.25 0 0 1 1.609-.446l.118.067 8.9 5.7a1.25 1.25 0 0 1 .118 2.02l-.115.084-36.3 23.4a1.25 1.25 0 0 1-1.227.071l-.127-.071-36.3-23.4a1.25 1.25 0 0 1-.111-2.022l.115-.082 8.6-5.5a1.25 1.25 0 0 1 1.457 2.027l-.11.08-6.961 4.45L40.3 52.512l33.987-21.909-7.261-4.65a1.25 1.25 0 0 1-.446-1.609l.067-.118z",
    fill: "#078CDF"
  }), jsx("path", {
    d: "M32.073 34h-4.399l-.733-5.077h-5.376L20.832 34H16.8l4.43-28h6.414l4.429 28zm-9.958-8.892h4.215l-2.107-14.154-2.108 14.154zm30.001-12.185v3.63c0 4.493-2.107 6.924-6.41 6.924h-2.015V34h-4.303V6h6.319c4.302 0 6.409 2.43 6.409 6.923zM43.69 10v9.477h2.016c1.384 0 2.106-.646 2.106-2.646v-4.185c0-2-.722-2.646-2.106-2.646H43.69zm15.463-4h5.09v28h-5.09z",
    fill: "#044E7C"
  })));
};

var SvgLogo = function SvgLogo(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 34 34",
    width: 34,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m30.377 24.992-12.662-5.903a1.888 1.888 0 0 0-.319-.11v-3.581c0-.35.013-.356.239-.46l.503-.234c.849-.394.849-.394 5.84-2.73l6.4-2.997c.37-.173.609-.55.609-.958 0-.41-.24-.785-.61-.958l-12.663-5.9a1.71 1.71 0 0 0-1.445-.002L3.612 7.044A1.066 1.066 0 0 0 3 7.996v17.935c0 .41.238.785.608.957l12.677 5.935c.099.047.2.08.306.107v.045l.394.007h.034l.377.004v-.047c.117-.026.233-.066.342-.116l12.64-5.918c.37-.172.609-.55.609-.957 0-.408-.24-.783-.61-.956zm-26.571-.11V9.053l12.48 5.842c.104.049.21.087.322.113.003 0 .007.004.01.004a2.25 2.25 0 0 0-.026.386v3.58l-.024.007c-.101.027-.2.058-.297.104L3.806 24.883zM3.95 7.776 16.61 1.89a.908.908 0 0 1 .764 0l12.66 5.903a.253.253 0 0 1 0 .456l-6.397 2.995c-4.992 2.336-4.992 2.336-5.839 2.73l-.477.222c-.036.014-.071.021-.107.03l-.049.014a.911.911 0 0 1-.539-.073L3.95 8.228a.207.207 0 0 1-.058-.037.252.252 0 0 1 .058-.417zm0 18.385a.253.253 0 0 1 0-.456l12.639-5.875v12.248L3.95 26.16zm26.087.017-12.64 5.917h-.003V19.83l12.64 5.891a.253.253 0 0 1 .003.457z",
    fill: "#2A4148"
  }));
};

var SvgMerchantCenterSmall = function SvgMerchantCenterSmall(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 25 25",
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "none"
  }, jsx("path", {
    d: "M22.447 24.148h-20.2l-1.7-1.7v-1.3h9.4l.7.7h3.4l.7-.7h9.4v1.3l-1.7 1.7zm-19.9-.8h19.6l1.2-1.2v-.2h-8.3l-.7.7h-4l-.7-.7h-8.3v.2l1.2 1.2zm19.4-2.9h-.8v-10.4c0-.4-.3-.7-.7-.7h-16.2c-.4 0-.7.3-.7.7v10.3h-.8v-10.3c0-.8.7-1.5 1.5-1.5h16.2c.8 0 1.5.7 1.5 1.5v10.4z",
    fill: "#507787"
  }), jsx("path", {
    d: "M18.947 7.848h-.8v-.4h-.3c-1 0-1.9-.8-1.9-1.9 0-.6.3-1.2.8-1.6-.2-.3-.5-.5-.7-.7-.3.5-.9.8-1.6.8-1 0-1.9-.8-1.9-1.9v-.3h-.7v.3c0 1-.8 1.9-1.9 1.9-.6 0-1.2-.3-1.6-.8-.3.2-.5.5-.7.7.5.3.8.9.8 1.6 0 1-.8 1.9-1.9 1.9h-.3v.4h-.8c0-.3 0-.6.1-1 0-.1.1-.2.2-.3.1-.1.2-.1.4 0s.3.1.5.1c.6 0 1.1-.5 1.1-1.1 0-.5-.3-.9-.8-1-.1 0-.2-.1-.3-.2 0-.1 0-.3.1-.4.4-.6 1-1.1 1.6-1.6.1-.1.2-.1.4-.1.1 0 .2.1.2.3.1.5.6.8 1 .8.6 0 1.1-.5 1.1-1.1 0-.2 0-.3-.1-.5-.1-.1-.1-.2 0-.4.1-.1.2-.2.3-.2.7-.1 1.2-.1 1.9 0 .1 0 .2.1.3.2.1.1.1.2 0 .4s-.1.3-.1.5c0 .6.5 1.1 1.1 1.1.5 0 .9-.3 1-.8 0-.1.1-.2.2-.3.1 0 .3 0 .4.1.6.4 1.1 1 1.6 1.6.1.1.1.2.1.4 0 .1-.1.2-.3.2-.5.1-.8.6-.8 1 0 .6.5 1.1 1.1 1.1.2 0 .3 0 .5-.1.1-.1.2-.1.4 0 .1.1.2.2.2.3.1.4.1.7.1 1z",
    fill: "#044E7C"
  }), jsx("path", {
    d: "M15.647 7.848h-.8c0-1.4-1.1-2.6-2.6-2.6s-2.6 1.1-2.6 2.6h-.7c0-1.8 1.5-3.3 3.3-3.3 1.9 0 3.4 1.5 3.4 3.3z",
    fill: "#044E7C"
  }), jsx("path", {
    d: "M20.247 20.248h-15.8v-10h15.8v10zm-15.1-.7h14.2v-8.6h-14.2v8.6z",
    fill: "#507787"
  })));
};

var SvgMerchantCenter = function SvgMerchantCenter(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 80 80",
    width: 80,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "none"
  }, jsx("path", {
    d: "M32.618 65.95H2.75v4.068l5.432 5.432h64.244l5.324-5.44v-4.06H47.998l-2.401 2.3h-10.68l-2.3-2.3zm42.632 2.5v.539l-3.877 3.961H9.217L5.25 68.983v-.533h26.333l2.3 2.3h12.72L49 68.45h26.25zM66 26.15c2.518 0 4.63 2.041 4.745 4.535l.005.215v32.8h-2.5V30.9c0-1.16-.955-2.163-2.1-2.245L66 28.65H14.5c-1.16 0-2.163.955-2.245 2.1l-.005.15v32.8h-2.5V30.9c0-2.518 2.041-4.63 4.535-4.745l.215-.005H66z",
    fill: "#507787"
  }), jsx("path", {
    d: "m61.244 20.876.11 1.127.03.349c.033.417.053.8.062 1.174l.004.374h-2.5c0-.32-.011-.642-.033-.992l-.018-.244-.07.013a5.875 5.875 0 0 1-.615.065l-.314.008c-3.29 0-5.95-2.66-5.95-5.95 0-1.98.984-3.765 2.548-4.857l.154-.103-.033-.04A19.776 19.776 0 0 0 52.4 9.58l-.049-.041-.108.162c-1.042 1.49-2.699 2.464-4.594 2.543l-.249.005a5.945 5.945 0 0 1-5.877-6.88l.013-.074c-.36-.025-.681-.04-.998-.044L40.3 5.25c-.32 0-.642.011-.992.033l-.244.017.013.07c.032.202.054.407.065.616l.008.314c0 3.29-2.66 5.95-5.95 5.95a5.913 5.913 0 0 1-4.857-2.548l-.103-.155-.04.034a19.776 19.776 0 0 0-2.22 2.219l-.041.048.162.109c1.49 1.042 2.464 2.699 2.543 4.594l.005.249a5.945 5.945 0 0 1-6.88 5.877l-.074-.014c-.025.36-.04.682-.044 1l-.002.237h-2.5c0-.272.006-.54.018-.815l.032-.564.023-.298.058-.64.077-.721a1.25 1.25 0 0 1 1.801-.98A3.445 3.445 0 0 0 26.15 16.8c0-1.536-1.026-2.834-2.526-3.308a1.25 1.25 0 0 1-.637-1.924 22.21 22.21 0 0 1 4.981-4.981 1.25 1.25 0 0 1 1.93.654c.448 1.495 1.779 2.509 3.302 2.509a3.445 3.445 0 0 0 3.082-4.991 1.25 1.25 0 0 1 .872-1.785l.12-.018 1.129-.11.349-.03a18.414 18.414 0 0 1 2.363-.048l.564.032.298.023.64.058.721.077a1.25 1.25 0 0 1 .98 1.801A3.445 3.445 0 0 0 47.4 9.75c1.536 0 2.834-1.026 3.308-2.526a1.25 1.25 0 0 1 1.924-.637 22.21 22.21 0 0 1 4.981 4.981 1.25 1.25 0 0 1-.654 1.93c-1.495.448-2.509 1.779-2.509 3.302a3.445 3.445 0 0 0 4.991 3.082 1.25 1.25 0 0 1 1.803.994z",
    fill: "#044E7C"
  }), jsx("path", {
    d: "M40.3 19.15c2.518 0 4.63 2.041 4.745 4.535l.005.215h-2.5c0-1.21-1.04-2.25-2.25-2.25-1.16 0-2.163.955-2.245 2.1l-.005.15h-2.5c0-2.59 2.16-4.75 4.75-4.75z",
    fill: "#044E7C"
  }), jsx("path", {
    d: "M40.3 13.25a10.639 10.639 0 0 1 10.646 10.366l.004.284h-2.5a8.14 8.14 0 0 0-8.15-8.15 8.139 8.139 0 0 0-8.146 7.9l-.004.25h-2.5c0-5.89 4.76-10.65 10.65-10.65z",
    fill: "#044E7C"
  }), jsx("path", {
    d: "M63.65 32.35h-46.8v29.9h46.8v-29.9zm-2.501 2.5v24.9h-41.8v-24.9h41.8z",
    fill: "#507787"
  })));
};

var SvgOpenSourceSmall = function SvgOpenSourceSmall(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 25 25",
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "none"
  }, jsx("path", {
    d: "M5.6 12.5h-.8V6c0-.6.5-1.2 1.2-1.2h4.2v.8H6c-.2 0-.4.2-.4.4v6.5zm6.9 7.7H6c-.6 0-1.2-.5-1.2-1.2v-4.2h.8V19c0 .2.2.4.4.4h6.5v.8zm6.5 0h-4.2v-.8H19c.2 0 .4-.2.4-.4v-6.5h.8V19c0 .7-.5 1.2-1.2 1.2zm1.2-10h-.8V6c0-.2-.2-.4-.4-.4h-6.5v-.8H19c.6 0 1.2.5 1.2 1.2v4.2z",
    fill: "gray"
  }), jsx("path", {
    d: "M12.5 5.6c-1.3 0-2.3-1-2.3-2.3 0-1.3 1-2.3 2.3-2.3 1.3 0 2.3 1 2.3 2.3 0 1.3-1 2.3-2.3 2.3zm0-3.9c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5S14 4 14 3.2s-.7-1.5-1.5-1.5zm9.2 13.1c-1.3 0-2.3-1-2.3-2.3 0-1.3 1-2.3 2.3-2.3 1.3 0 2.3 1 2.3 2.3 0 1.3-1 2.3-2.3 2.3zm0-3.8c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.6-1.5-1.5-1.5zm-9.2 13c-1.3 0-2.3-1-2.3-2.3 0-1.3 1-2.3 2.3-2.3 1.3 0 2.3 1 2.3 2.3 0 1.3-1 2.3-2.3 2.3zm0-3.8c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5zm-9.2-5.4c-1.3 0-2.3-1-2.3-2.3 0-1.3 1-2.3 2.3-2.3 1.3 0 2.3 1 2.3 2.3 0 1.3-1 2.3-2.3 2.3zm0-3.8c-.8 0-1.5.7-1.5 1.5S2.4 14 3.3 14s1.5-.7 1.5-1.5S4.1 11 3.3 11z",
    fill: "gray"
  }), jsx("path", {
    fill: "#044E7C",
    d: "m9.5 14.7-2.2-2.2 2.2-2.2.6.6-1.7 1.6 1.7 1.6zm6 0-.6-.6 1.7-1.6-1.7-1.6.6-.6 2.2 2.2zm-5.294 1.102 3.839-6.905.874.485-3.838 6.905z"
  })));
};

var SvgOpenSource = function SvgOpenSource(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 80 80",
    width: 80,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "none"
  }, jsx("path", {
    d: "M32.867 15.489v2.5h-13.5c-.57 0-1.078.47-1.143 1.029l-.007.12v20.7h-2.5v-20.7c0-1.925 1.554-3.542 3.458-3.644l.192-.005h13.5zm-14.55 31.75v13.4c0 .569.47 1.077 1.029 1.143l.12.007h20.7v2.5h-20.7c-1.925 0-3.542-1.555-3.644-3.459l-.005-.191v-13.4h2.5zm46.3-7.4v20.7c0 1.926-1.555 3.542-3.459 3.645l-.191.005h-13.5v-2.5h13.5c.569 0 1.077-.471 1.143-1.03l.007-.12v-20.7h2.5zm-3.75-24.45c1.926 0 3.542 1.554 3.645 3.458l.005.192v13.4h-2.5v-13.4c0-.57-.47-1.078-1.03-1.143l-.12-.007h-20.7v-2.5h20.7z",
    fill: "gray"
  }), jsx("path", {
    d: "M40.167 3.189a7.35 7.35 0 1 0 0 14.7 7.35 7.35 0 0 0 0-14.7zm0 2.5a4.85 4.85 0 1 1 0 9.7 4.85 4.85 0 0 1 0-9.7zm29.3 26.8a7.35 7.35 0 1 0 0 14.7 7.35 7.35 0 0 0 0-14.7zm0 2.5a4.85 4.85 0 1 1 0 9.7 4.85 4.85 0 0 1 0-9.7zm-29.3 26.8a7.35 7.35 0 1 0 0 14.7 7.35 7.35 0 0 0 0-14.7zm0 2.5a4.85 4.85 0 1 1 0 9.7 4.85 4.85 0 0 1 0-9.7zm-29.3-31.8a7.35 7.35 0 1 0 0 14.7 7.35 7.35 0 0 0 0-14.7zm0 2.5a4.85 4.85 0 1 1 0 9.7 4.85 4.85 0 0 1 0-9.7z",
    fill: "gray"
  }), jsx("path", {
    fill: "#044E7C",
    d: "m30.783 32.855 1.768 1.768-5.217 5.215 5.217 5.217-1.768 1.768-6.984-6.984zm18.767 0 6.985 6.984-6.984 6.984-1.768-1.768 5.215-5.217-5.215-5.215zm-4.376-4.622 2.186 1.212-12.2 22-2.186-1.212z"
  })));
};

var SvgRibbon = function SvgRibbon(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M12.322 2h-8.63C3.304 2 3 2.278 3 2.632v10.736c0 .227.138.442.36.555a.705.705 0 0 0 .705-.038l3.942-2.4 3.928 2.413a.68.68 0 0 0 .387.101.69.69 0 0 0 .318-.076.636.636 0 0 0 .36-.555V2.632c.013-.354-.29-.632-.678-.632z",
    fill: "#E6E6E6",
    fillRule: "evenodd"
  }));
};

var SvgTutorialsSmall = function SvgTutorialsSmall(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 25 25",
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, jsx("path", {
    d: "M4.2 23.9h-.1c-.1-.1-.2-.2-.2-.4v-4.3h-2c-.5 0-.9-.4-.9-.9V1.9c0-.5.4-.9.9-.9h20.8c.5 0 .9.4.9.9v16.4c0 .5-.4.9-.9.9H9.1l-4.6 4.6c-.1.1-.2.1-.3.1zm-2.4-22c-.1 0-.1 0 0 0l-.1 16.5s0 .1.1.1h2.4c.2 0 .4.2.4.4v3.8l4.1-4.1c.1-.1.2-.1.3-.1h13.7s.1 0 .1-.1V1.9s0-.1-.1-.1H1.8v.1z",
    fill: "#044E7C",
    fillRule: "nonzero"
  }), jsx("path", {
    d: "M10.5 12.9c-.1 0-.3 0-.4-.1-.2-.1-.3-.3-.3-.6V8.1c0-.2.1-.5.3-.6.2-.1.5-.1.7 0l4.1 2.1c.2.1.4.4.4.6 0 .3-.1.5-.4.6l-4.1 2.1h-.3z",
    fill: "#078CDF",
    fillRule: "nonzero"
  }), jsx("path", {
    d: "M10.5 12.9c-.1 0-.3 0-.4-.1-.2-.1-.3-.3-.3-.6V8.1c0-.2.1-.5.3-.6.2-.1.5-.1.7 0l4.1 2.1c.2.1.4.4.4.6 0 .3-.1.5-.4.6l-4.1 2.1h-.3z"
  }), jsx("path", {
    d: "M12.2 16.7c-3.6 0-6.6-3-6.6-6.6 0-3.6 3-6.6 6.6-6.6 3.6 0 6.6 3 6.6 6.6 0 3.6-3 6.6-6.6 6.6zm0-12.4c-3.2 0-5.8 2.6-5.8 5.8 0 3.2 2.6 5.8 5.8 5.8 3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8z",
    fill: "#078CDF",
    fillRule: "nonzero"
  })));
};

var SvgTutorials = function SvgTutorials(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 80 80",
    width: 80,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, jsx("path", {
    d: "M25.2 3.15H6.9c-1.49 0-2.75 1.26-2.75 2.75v52.8l.005.165c.089 1.417 1.31 2.585 2.745 2.585l6.35-.001V75.5l.005.121c.094 1.032 1.37 1.521 2.129.763l14.933-14.935 43.783.001c1.49 0 2.75-1.26 2.75-2.75V6l-.005-.165c-.089-1.417-1.31-2.585-2.745-2.585l-48.413-.002a1.246 1.246 0 0 0-.487-.098zM6.9 5.65l17.809-.001c.154.066.318.101.491.101h48.9c.11 0 .25.14.25.25v52.7c0 .11-.14.25-.25.25H29.8l-.141.008a1.25 1.25 0 0 0-.743.358L15.75 72.482V60.2c0-.69-.56-1.25-1.25-1.25H6.9c-.11 0-.25-.14-.25-.25V5.9c0-.11.14-.25.25-.25z",
    fill: "#044E7C",
    fillRule: "nonzero"
  }), jsx("path", {
    d: "M34.1 39.1V25.8c0-.7.8-1.2 1.4-.9l13.3 6.7c.7.4.7 1.4 0 1.7L35.5 40c-.6.2-1.4-.2-1.4-.9z",
    fill: "#078CDF"
  }), jsx("path", {
    d: "M40.5 11.15c-11.736 0-21.25 9.514-21.25 21.25s9.514 21.25 21.25 21.25 21.25-9.514 21.25-21.25-9.514-21.25-21.25-21.25zm0 2.5c10.355 0 18.75 8.395 18.75 18.75S50.855 51.15 40.5 51.15 21.75 42.755 21.75 32.4s8.395-18.75 18.75-18.75z",
    fill: "#078CDF",
    fillRule: "nonzero"
  })));
};

function _createForOfIteratorHelper$1(o, allowArrayLike) {
  var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"];

  if (!it) {
    if (_Array$isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray$1(o, minLen) {
  var _context2;

  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);

  var n = _sliceInstanceProperty(_context2 = Object.prototype.toString.call(o)).call(_context2, 8, -1);

  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return _Array$from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
/* eslint-disable */
// From https://github.com/euank/node-parse-numeric-range
// The package does not ship with CommonJS modules, so we just copy over the implementation.


function parsePart(string) {
  var _context;

  var res = [],
      m;

  var _iterator = _createForOfIteratorHelper$1(_mapInstanceProperty(_context = string.split(',')).call(_context, function (str) {
    return _trimInstanceProperty(str).call(str);
  })),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var str = _step.value; // just a number

      if (/^-?\d+$/.test(str)) {
        res.push(_parseInt(str, 10));
      } else if (m = str.match(/^(-?\d+)(-|\.\.\.?|\u2025|\u2026|\u22EF)(-?\d+)$/)) {
        // 1-5 or 1..5 (equivilant) or 1...5 (doesn't include 5)
        var _m = m,
            _m2 = _slicedToArray(_m, 4),
            _ = _m2[0],
            lhs = _m2[1],
            sep = _m2[2],
            rhs = _m2[3];

        if (lhs && rhs) {
          lhs = _parseInt(lhs);
          rhs = _parseInt(rhs);
          var incr = lhs < rhs ? 1 : -1; // Make it inclusive by moving the right 'stop-point' away by one.

          if (sep === '-' || sep === '..' || sep === "\u2025") rhs += incr;

          for (var i = lhs; i !== rhs; i += incr) {
            res.push(i);
          }
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return res;
}

function ownKeys$4(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
      return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var _context4, _context5;

    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? _forEachInstanceProperty(_context4 = ownKeys$4(Object(source), !0)).call(_context4, function (key) {
      _defineProperty(target, key, source[key]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context5 = ownKeys$4(Object(source))).call(_context5, function (key) {
      _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"];

  if (!it) {
    if (_Array$isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  var _context3;

  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);

  var n = _sliceInstanceProperty(_context3 = Object.prototype.toString.call(o)).call(_context3, 8, -1);

  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return _Array$from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _wrapRegExp() {
  _wrapRegExp = function _wrapRegExp(re, groups) {
    return new BabelRegExp(re, void 0, groups);
  };

  var _super = RegExp.prototype,
      _groups = new _WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  function buildGroups(result, re) {
    var _context2;

    var g = _groups.get(re);

    return _reduceInstanceProperty(_context2 = _Object$keys(g)).call(_context2, function (groups, name) {
      return groups[name] = result[g[name]], groups;
    }, _Object$create(null));
  }

  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    return result && (result.groups = buildGroups(result, this)), result;
  }, BabelRegExp.prototype[_Symbol$replace] = function (str, substitution) {
    if ("string" == typeof substitution) {
      var groups = _groups.get(this);

      return _super[_Symbol$replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    }

    if ("function" == typeof substitution) {
      var _this = this;

      return _super[_Symbol$replace].call(this, str, function () {
        var args = arguments;
        return "object" != typeof args[args.length - 1] && (args = _sliceInstanceProperty([]).call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
      });
    }

    return _super[_Symbol$replace].call(this, str, substitution);
  }, _wrapRegExp.apply(this, arguments);
}

var defaultOptions = {
  title: '',
  highlightLines: [],
  noPromptLines: [],
  secondaryTheme: false
};

var getLinesForRange = function getLinesForRange(value) {
  var _context;

  return value && typeof value === 'string' ? _filterInstanceProperty(_context = parsePart(_trimInstanceProperty(value).call(value))).call(_context, function (n) {
    return n > 0;
  }) : [];
}; // We need to parse the `metastring` value on our own as the default
// MDX implementation does not support values with whitespaces.
// https://github.com/mdx-js/mdx/blob/e95e2c114bead01164a8af068ae052cebf1534c2/packages/mdx/mdx-ast-to-mdx-hast.js#L38-L46
// We mostly need this for things like `title="This is a title"`.
// returns one match per attribute-value pair, containing named capture groups
// "attribute" and either one of the "value_*" groups
// Saved here for testing and editing: https://regex101.com/r/DKJjaO/1


var parseOptionsRegex = /*#__PURE__*/_wrapRegExp(/([0-9A-Z_a-z]+)(="(.*?)"|='(.*?)'|=([\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uFEFE\uFF00-\uFFFF]*)|)/g, {
  attribute: 1,
  value_doublequote: 3,
  value_singlequote: 4,
  value_noquote: 5
});

var parseOptionsString = function parseOptionsString(optionsString) {
  var parsedOptions = {};

  var matches = _Array$from(_matchAllInstanceProperty(optionsString).call(optionsString, parseOptionsRegex));

  var _iterator = _createForOfIteratorHelper(matches),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _match$groups;

      var match = _step.value;

      if (match !== null && match !== void 0 && (_match$groups = match.groups) !== null && _match$groups !== void 0 && _match$groups.attribute) {
        var _match$groups2, _match$groups3, _match$groups4;

        parsedOptions[match.groups.attribute] = (match === null || match === void 0 ? void 0 : (_match$groups2 = match.groups) === null || _match$groups2 === void 0 ? void 0 : _match$groups2.value_doublequote) || (match === null || match === void 0 ? void 0 : (_match$groups3 = match.groups) === null || _match$groups3 === void 0 ? void 0 : _match$groups3.value_singlequote) || (match === null || match === void 0 ? void 0 : (_match$groups4 = match.groups) === null || _match$groups4 === void 0 ? void 0 : _match$groups4.value_noquote) || true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return parsedOptions;
};

function parseCodeBlockOptions() {
  var _rawOptions$title;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    metastring: ''
  };
  if (!props.metastring) return defaultOptions;
  var rawOptions = parseOptionsString(props.metastring);
  if (rawOptions.secondaryTheme === 'false') rawOptions.secondaryTheme = false; // Boolean("false") = true

  return _objectSpread$4(_objectSpread$4({}, defaultOptions), {}, {
    title: (_rawOptions$title = rawOptions.title) === null || _rawOptions$title === void 0 ? void 0 : _rawOptions$title.toString(),
    highlightLines: getLinesForRange(rawOptions.highlightLines),
    noPromptLines: getLinesForRange(rawOptions.noPromptLines),
    secondaryTheme: Boolean(rawOptions.secondaryTheme)
  });
}

var _context$1;

function ownKeys$3(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
      return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var _context2, _context3;

    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? _forEachInstanceProperty(_context2 = ownKeys$3(Object(source), !0)).call(_context2, function (key) {
      _defineProperty(target, key, source[key]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context3 = ownKeys$3(Object(source))).call(_context3, function (key) {
      _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var commercetoolsTheme = _objectSpread$3({}, nightOwl); // for the defaults see
// https://github.com/FormidableLabs/prism-react-renderer/blob/master/src/themes/nightOwl.js
// current changes:
// - less "neon" variation of the "string", new: rgb(192,228,139)
// - swap "property" and "string"/"url"/"inserted"/"attr-name" to make typical code less "glaring"
//   and to hightlight the property keys in JSON which eases understanding the structure.
// need to recreate this prismic type, it's not exported.


var italicStyle$1 = 'italic';
var additionalStyles$1 = [{
  types: ['string', 'url'],
  style: {
    color: 'rgb(128, 203, 196)'
  }
}, {
  types: ['inserted', 'attr-name'],
  style: {
    color: 'rgb(128, 203, 196)',
    fontStyle: italicStyle$1
  }
}, {
  types: ['property'],
  style: {
    color: 'rgb(192,228,139)'
  }
}];
commercetoolsTheme.styles = _concatInstanceProperty(_context$1 = []).call(_context$1, _toConsumableArray(nightOwl.styles), additionalStyles$1);

var _context;

function ownKeys$2(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
      return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var _context2, _context3;

    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? _forEachInstanceProperty(_context2 = ownKeys$2(Object(source), !0)).call(_context2, function (key) {
      _defineProperty(target, key, source[key]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context3 = ownKeys$2(Object(source))).call(_context3, function (key) {
      _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var commercetoolsLightTheme = _objectSpread$2({}, nightOwlLight); // Goal: Optimize JSON, leave others alone.
// variations:
// - swap rgb(72, 118, 214)  and rgb(12, 150, 155) to have string literals
//   in green in both light and dark because they occur side by side in API docs.
// - booleans and numbers in a tone that's visually similar to the dark variant.
// need to recreate this prismic type, it's not exported.


var italicStyle = 'italic';
var additionalStyles = [{
  types: ['operator', 'keyword', 'property', 'namespace'],
  style: {
    color: 'rgb(72, 118, 214)'
  }
}, {
  types: ['inserted', 'attr-name'],
  style: {
    color: 'rgb(12, 150, 155)',
    fontStyle: italicStyle
  }
}, {
  types: ['string', 'builtin', 'char', 'constant', 'url'],
  style: {
    color: 'rgb(12, 150, 155)'
  }
}, {
  types: ['boolean'],
  style: {
    color: 'rgb(255, 20, 40)'
  }
}, {
  types: ['number'],
  style: {
    color: 'rgb(247, 70, 54)'
  }
}];
commercetoolsLightTheme.styles = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(commercetoolsLightTheme.styles), additionalStyles);

var getSelection = function getSelection(document) {
  var selection = document.getSelection();
  return selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : false;
};

var createTextArea = function createTextArea(document, text) {
  var el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px'; // Move outside the screen to make it invisible

  return el;
};

var copyToClipboard = function copyToClipboard(text) {
  var el = createTextArea(document, text);
  var selected = getSelection(document);
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);

  if (selected) {
    var _document$getSelectio, _document$getSelectio2;

    (_document$getSelectio = document.getSelection()) === null || _document$getSelectio === void 0 ? void 0 : _document$getSelectio.removeAllRanges();
    (_document$getSelectio2 = document.getSelection()) === null || _document$getSelectio2 === void 0 ? void 0 : _document$getSelectio2.addRange(selected);
  }
};

function ownKeys$1(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
      return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var _context4, _context5;

    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? _forEachInstanceProperty(_context4 = ownKeys$1(Object(source), !0)).call(_context4, function (key) {
      _defineProperty(target, key, source[key]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context5 = ownKeys$1(Object(source))).call(_context5, function (key) {
      _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var HighlightedContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1vt669h2"
} : {
  target: "e1vt669h2",
  label: "HighlightedContainer"
})("background-color:", function (props) {
  return props.theme.codeBlockColors.surface;
}, ";border-radius:", tokens.borderRadiusForCodeBlock, ";margin:0;padding:", dimensions.spacings.s, " ", dimensions.spacings.xs, " ", dimensions.spacings.s, " ", dimensions.spacings.m, ";overflow:auto;");

var Preformatted = _styled("pre", process.env.NODE_ENV === "production" ? {
  target: "e1vt669h1"
} : {
  target: "e1vt669h1",
  label: "Preformatted"
})("font-family:", typography.fontFamilies.code, ";font-size:", typography.fontSizes.small, ";background-color:", function (props) {
  return props.theme.codeBlockColors.surface;
}, "!important;margin:0;padding:0;width:100%;white-space:pre-wrap;");

var CopyArea = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1vt669h0"
} : {
  target: "e1vt669h0",
  label: "CopyArea"
})("cursor:pointer;svg{fill:", function (props) {
  return props.theme.codeBlockColors.surfaceCopyIcon;
}, ";}:hover{svg{fill:", function (props) {
  return props.theme.codeBlockColors.surfaceCopyIconHover;
}, ";}}");

var TooltipWrapperComponent = function TooltipWrapperComponent(props) {
  return /*#__PURE__*/ReactDOM.createPortal(props.children, document.body);
};

var TooltipBodyComponent = function TooltipBodyComponent(props) {
  var theme = useTheme();
  return jsx("div", _extends({
    css: /*#__PURE__*/css("background-color:", theme.codeBlockColors.surfaceCopyTooltip, ";border-radius:", tokens.borderRadiusForTooltip, ";color:", theme.codeBlockColors.textCopyTooltip, ";font-size:", typography.fontSizes.extraSmall, ";padding:", dimensions.spacings.xs, " ", dimensions.spacings.s, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:TooltipBodyComponent;"))
  }, props));
};

var getLineStyles = function getLineStyles(theme, options) {
  var promptLineStyles;
  var highlightLineStyles;

  if (options.isCommandLine) {
    promptLineStyles = /*#__PURE__*/css("margin:0 0 0 ", dimensions.spacings.m, ";::before{content:attr(data-prompt);margin:0 0 0 -", dimensions.spacings.m, ";padding:0 ", dimensions.spacings.s, " 0 0;color:", options.shouldShowPrompt ? theme.codeBlockColors.surfacePrompt : 'transparent', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:promptLineStyles;"));
  }

  if (options.shouldHighlightLine) {
    var width = options.isCommandLine ? "calc(100% - ".concat(dimensions.spacings.s, ")") : '100%';
    highlightLineStyles = /*#__PURE__*/css("background-color:", theme.codeBlockColors.surfaceLineHighlight, ";width:", width, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:highlightLineStyles;"));
  }

  return [promptLineStyles, highlightLineStyles];
};
/**
 * This components implements most of the logic from `gatsby-remark-prismjs`.
 * https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby-remark-prismjs
 *
 * We need to implement this logic on our own (at least for now) because of the
 * copy-to-clipboard functionality, as we need access to the raw content.
 * If we were to use the gatsby plugin, we would get the formatted content from props.
 *
 * ## Description
 * The CodeBlock component is used to provide syntax highlighting to the markdown
 * code block syntax ```.
 * It supports all the "common languages" as well as some extra features.
 *
 * ## Usage
 * The normal way to use it is by adding the appropriate language of your choice next
 * to the code block syntax:
 *
 * ```javascript
 * // This is a js comment
 * ```
 *
 * ## Additional features
 * The CodeBlock component also supports optional features to enhance the final output.
 * Those features are controlled by using the "infostring" syntax supported by MDX.
 * https://github.com/mdx-js/mdx/pull/257
 *
 * ```javascript foo=bar
 * // This is a js comment
 * ```
 *
 * Given the above syntax, the CodeBlock component will receive the following props:
 *
 * {
 *   children: {
 *    props: {
 *      children: '// This is a js comment',
 *      className: 'language-javascript',
 *      foo: 'bar',
 *      mdxType: 'code',
 *      metastring: 'foo=bar',
 *      originalType: 'code',
 *      parentName: 'pre',
 *    }
 *   }
 * }
 *
 * However, to support values with whitespaces between words (e.g. `title="This is a title"`)
 * we need to add a **restriction to always wrap the value in quotes**!
 *
 * ### Title
 * This feature allows to pass a title to the code block header.
 * To use this, you need to pass `title="<title>"`.
 *
 * ```javascript title="Sum function implementation"
 * const sum = (x, y) => {
 *   if (typeof x !== 'number' || typeof y !== 'number') {
 *     throw new Error('Both arguments need to be numbers.');
 *   }
 *   return x + y;
 * }
 * ```
 *
 * ### Highlighted lines
 * This feature allows to select lines to be visually highlighted in the final output.
 * To use this, you need to pass `highlightLines="<range>"`. The range can be a single line
 * number or a range of line numbers separated by `-`. Multiple highlighted lines can be
 * provided as comma-separated values.
 *
 * ```javascript highlightLines="1,5"
 * const sum = (x, y) => {
 *   if (typeof x !== 'number' || typeof y !== 'number') {
 *     throw new Error('Both arguments need to be numbers.');
 *   }
 *   return x + y;
 * }
 * ```
 *
 * ### Prompt lines
 * This feature allows to remove the prompt `$` from the specified lines.
 * To use this, you need to pass `noPromptLines="<range>"`. The range can be a single line
 * number or a range of line numbers separated by `-`. Multiple lines can be
 * provided as comma-separated values.
 * This feature only works for the `console` or `terminal` language syntax.
 *
 * ```console noPromptLines="1-2,5-6"
 * cd project
 * cp -R \
 *   dist \
 *   public/
 * rm -rf dist
 * yarn start
 * ```
 */


var languageAliases = {
  sh: 'bash',
  zsh: 'bash',
  console: 'bash',
  terminal: 'bash',
  curl: 'bash',
  js: 'javascript',
  yml: 'yaml'
};

var CodeBlock = function CodeBlock(props) {
  var _context;

  var languageCode = props.language || 'text';
  var language = languageAliases[languageCode] || languageCode;

  var isCommandLine = _includesInstanceProperty(_context = ['terminal', 'console']).call(_context, languageCode); // Copy to clipboard logic


  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isCopiedToClipboard = _React$useState2[0],
      setIsCopiedToClipboard = _React$useState2[1];

  var handleCopyToClipboardClick = function handleCopyToClipboardClick() {
    copyToClipboard(props.content);
    setIsCopiedToClipboard(true);

    _setTimeout(function () {
      setIsCopiedToClipboard(false);
    }, 1500);
  };

  var codeBlockTheme = {
    codeBlockColors: colors.light.codeBlocks[props.secondaryTheme ? 'secondary' : 'primary']
  };
  return jsx(ThemeProvider, {
    theme: codeBlockTheme
  }, jsx(Highlight, _extends({}, defaultProps, {
    code: props.content,
    language: language,
    theme: props.secondaryTheme ? commercetoolsLightTheme : commercetoolsTheme
  }), function (_ref) {
    var className = _ref.className,
        style = _ref.style,
        syntaxTokens = _ref.tokens,
        getLineProps = _ref.getLineProps,
        getTokenProps = _ref.getTokenProps;
    return jsx(HighlightedContainer, {
      theme: codeBlockTheme
    }, jsx(SpacingsInline, {
      scale: "xs",
      alignItems: "flex-start"
    }, jsx(Preformatted, {
      className: className,
      style: style,
      theme: codeBlockTheme
    }, _mapInstanceProperty(syntaxTokens).call(syntaxTokens, function (line, index) {
      var _context2, _context3;

      var isLastLine = syntaxTokens.length - 1 === index;

      if (isLastLine) {
        if (line.length === 1 && line[0].empty) {
          return null;
        }
      }

      var shouldShowPrompt = isCommandLine && props.noPromptLines ? !_includesInstanceProperty(_context2 = props.noPromptLines).call(_context2, index + 1) : false;
      var shouldHighlightLine = props.highlightLines && props.highlightLines.length > 0 ? _someInstanceProperty(_context3 = props.highlightLines).call(_context3, function (highlightine) {
        return highlightine === index + 1;
      }) : false;
      return jsx("div", _extends({
        key: index
      }, getLineProps(_objectSpread$1({
        line: line,
        key: index
      }, isCommandLine ? {
        'data-prompt': '$'
      } : {})), {
        css: getLineStyles(codeBlockTheme, {
          isCommandLine: isCommandLine,
          shouldShowPrompt: shouldShowPrompt,
          shouldHighlightLine: shouldHighlightLine
        })
      }), _mapInstanceProperty(line).call(line, function (token, key) {
        return jsx("span", _extends({
          key: key
        }, getTokenProps({
          token: token,
          key: key
        })));
      }));
    })), jsx(Tooltip, {
      placement: "left",
      title: isCopiedToClipboard ? 'Copied' : 'Copy to clipboard',
      components: {
        TooltipWrapperComponent: TooltipWrapperComponent,
        BodyComponent: TooltipBodyComponent
      }
    }, jsx(CopyArea, {
      onClick: handleCopyToClipboardClick,
      theme: codeBlockTheme
    }, jsx(ClipboardIcon, null)))));
  }));
};

CodeBlock.propTypes = process.env.NODE_ENV !== "production" ? {
  secondaryTheme: _pt.bool,
  language: _pt.string,
  highlightLines: _pt.arrayOf(_pt.number),
  noPromptLines: _pt.arrayOf(_pt.number),
  content: _pt.string.isRequired
} : {};

var Container$1 = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ee36co95"
} : {
  target: "ee36co95",
  label: "Container"
})("background-color:", function (props) {
  return props.theme.codeBlockColors.surface;
}, ";border:1px solid ", function (props) {
  return props.theme.codeBlockColors.border;
}, ";border-radius:", tokens.borderRadiusForCodeBlock, ";word-break:break-word;");

var Header = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ee36co94"
} : {
  target: "ee36co94",
  label: "Header"
})("background-color:", function (props) {
  return props.theme.codeBlockColors.surfaceHeader;
}, ";border-radius:", tokens.borderRadiusForCodeBlock, " ", tokens.borderRadiusForCodeBlock, " 0 0;border-bottom:1px solid ", function (props) {
  return props.theme.codeBlockColors.border;
}, ";padding:", dimensions.spacings.s, " ", dimensions.spacings.m, ";");

var HeaderInner = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ee36co93"
} : {
  target: "ee36co93",
  label: "HeaderInner"
})("display:grid;grid-gap:", dimensions.spacings.m, ";grid-template-columns:auto 1fr;");

var HeaderText = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "ee36co92"
} : {
  target: "ee36co92",
  label: "HeaderText"
})("color:", function (props) {
  return props.theme.codeBlockColors.textHeader;
}, ";");

var getCaretSvgUrl = function getCaretSvgUrl(color) {
  return "url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Icons' stroke='none' stroke-width='1' fill-rule='evenodd'%3E%3Cg id='MC-icon-set' transform='translate(-168.000000, -936.000000)' fill='%23".concat(color, "'%3E%3Cg id='Directions' transform='translate(24.000000, 888.000000)'%3E%3Cg id='Caret-Down' transform='translate(144.000000, 48.000000)'%3E%3Cpath d='M20.6658731,7.4053255 C20.4433682,7.16948908 20.1796129,7.05166867 19.8748538,7.05166867 L4.12508466,7.05166867 C3.82020235,7.05166867 3.55663185,7.16948908 3.33394217,7.4053255 C3.11125249,7.64142273 3,7.92055342 3,8.24323919 C3,8.56585976 3.11125249,8.84499045 3.33394217,9.08089208 L11.2088575,17.4207121 C11.4317935,17.6565485 11.695364,17.7746297 12,17.7746297 C12.304636,17.7746297 12.5684528,17.6565485 12.7909578,17.4207121 L20.6658731,9.08082687 C20.8883165,8.84499045 21,8.56585976 21,8.24317399 C21,7.92055342 20.8883165,7.64142273 20.6658731,7.4053255 L20.6658731,7.4053255 Z' id='shape'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")");
};

var LanguagesDropDownWrapper = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ee36co91"
} : {
  target: "ee36co91",
  label: "LanguagesDropDownWrapper"
})("background-image:", function (props) {
  return getCaretSvgUrl(props.theme.codeBlockColors.surfaceLanguageDropdown.replace('#', ''));
}, ";background-repeat:no-repeat,repeat;background-position:right 0 top 50%,0 0;background-size:", dimensions.widths.selectDropDownArrowWith, " auto,100%;");

var LanguagesDropDown = _styled("select", process.env.NODE_ENV === "production" ? {
  target: "ee36co90"
} : {
  target: "ee36co90",
  label: "LanguagesDropDown"
})("display:block;font-size:", typography.fontSizes.body, ";line-height:", typography.lineHeights.body, ";color:", function (props) {
  return props.theme.codeBlockColors.surfaceLanguageDropdown;
}, ";padding-right:", dimensions.spacings.m, ";box-sizing:border-box;cursor:pointer;border:none;appearance:none;background:transparent;option{color:black;}::-ms-expand{display:none;}:hover{color:", function (props) {
  return props.theme.codeBlockColors.surfaceLanguageDropdownHover;
}, ";}:focus{outline:none;}");

var languageDisplayNames = {
  sh: 'Terminal',
  zsh: 'Terminal',
  console: 'Terminal',
  bash: 'Terminal',
  curl: 'cURL',
  js: 'JavaScript',
  javascript: 'JavaScript',
  jsx: 'JavaScript React',
  java: 'Java',
  scala: 'Scala',
  php: 'PHP',
  cs: 'C#',
  ts: 'TypeScript',
  tsx: 'TypeScript React',
  python: 'Python',
  go: 'Go',
  swift: 'Swift',
  ruby: 'Ruby',
  objectivec: 'Objective-C'
};

function extractLanguages(children) {
  if (_Array$isArray(children)) {
    return _mapInstanceProperty(children).call(children, function (child) {
      return child.props.language;
    });
  }

  return [children.props.language];
}

function MultiCodeBlock(props) {
  var langs = extractLanguages(props.children);

  var _React$useState = React.useState(langs[0]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selected = _React$useState2[0],
      setSelected = _React$useState2[1];

  var handleOnLanguageChange = React.useCallback(function (event) {
    setSelected(event.target.value);
  }, []);
  var codeBlockTheme = {
    codeBlockColors: colors.light.codeBlocks[props.secondaryTheme ? 'secondary' : 'primary']
  };
  var selectedElement;

  if (_Array$isArray(props.children)) {
    var _context;

    selectedElement = _findInstanceProperty(_context = props.children).call(_context, function (child) {
      return child.props.language === selected;
    }) || undefined;
  } else {
    selectedElement = props.children;
  }

  return jsx(ThemeProvider, {
    theme: codeBlockTheme
  }, jsx(Container$1, {
    theme: codeBlockTheme
  }, props.title || langs.length > 1 ? jsx(Header, {
    theme: codeBlockTheme
  }, jsx(HeaderInner, null, jsx(HeaderText, {
    theme: codeBlockTheme
  }, props.title), jsx(SpacingsInline, {
    scale: "m",
    alignItems: "center",
    justifyContent: "flex-end"
  }, function () {
    if (langs.length > 1) {
      return jsx(LanguagesDropDownWrapper, {
        theme: codeBlockTheme
      }, jsx(LanguagesDropDown, {
        theme: codeBlockTheme,
        onChange: handleOnLanguageChange
      }, _mapInstanceProperty(langs).call(langs, function (lang) {
        return jsx("option", {
          key: lang,
          value: lang
        }, languageDisplayNames[lang] || lang);
      })));
    }

    return langs[0] === 'text' ? null : jsx(HeaderText, {
      theme: codeBlockTheme
    }, languageDisplayNames[langs[0]] || langs[0]);
  }()))) : null, selectedElement && /*#__PURE__*/React.cloneElement(selectedElement, {
    secondaryTheme: props.secondaryTheme
  })));
}

/* eslint-disable react/display-name */
// Maps the props coming from MDX to the underlying <CodeBlock> component.
var CodeBlockMarkdownWrapper = function CodeBlockMarkdownWrapper(props) {
  var childElement = reactIs.isElement(props.children) ? props.children : null;
  var childProps = childElement === null || childElement === void 0 ? void 0 : childElement.props;
  var className = childProps ? childProps.className : '';
  var languageToken = className || 'language-text';

  var _languageToken$split = languageToken.split('language-'),
      _languageToken$split2 = _slicedToArray(_languageToken$split, 2),
      languageCode = _languageToken$split2[1];

  var parsedOptions = parseCodeBlockOptions(childProps);
  var content = childProps && childProps.children ? childProps.children : childProps;
  return jsx(MultiCodeBlock, parsedOptions, jsx(CodeBlock, _extends({}, parsedOptions, {
    content: content,
    language: languageCode
  })));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var _ref$2 = process.env.NODE_ENV === "production" ? {
  name: "v5igdj",
  styles: "line-height:1.3"
} : {
  name: "1uku7t5-headerStyles",
  styles: "line-height:1.3;label:headerStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};

var headerStyles = function headerStyles() {
  return _ref$2;
};

var Paragraph = _styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a825"
} : {
  target: "e1yuh3a825",
  label: "Paragraph"
})(process.env.NODE_ENV === "production" ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ti75j2",
  styles: "margin:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});

var H1 = _styled("h1", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a824"
} : {
  target: "e1yuh3a824",
  label: "H1"
})(headerStyles, ";font-size:", typography.fontSizes.h1, ";font-weight:", typography.fontWeights.regular, ";line-height:1.15;color:", function (props) {
  return props.theme.websitePrimaryColor;
}, ";margin:0 0 ", dimensions.spacings.s, ";");

var H2 = _styled("h2", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a823"
} : {
  target: "e1yuh3a823",
  label: "H2"
})(headerStyles, ";font-size:", typography.fontSizes.h2, ";font-weight:", typography.fontWeights.bold, ";border-bottom:1px solid ", colors.light.borderPrimary, ";padding-bottom:", dimensions.spacings.s, ";");

var H3 = _styled("h3", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a822"
} : {
  target: "e1yuh3a822",
  label: "H3"
})(headerStyles, ";font-size:", typography.fontSizes.h3, ";font-weight:", typography.fontWeights.medium, ";");

var H4 = _styled("h4", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a821"
} : {
  target: "e1yuh3a821",
  label: "H4"
})(headerStyles, ";font-size:", typography.fontSizes.h4, ";font-weight:", typography.fontWeights.medium, ";");

var H5 = _styled("h5", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a820"
} : {
  target: "e1yuh3a820",
  label: "H5"
})(headerStyles, ";font-size:", typography.fontSizes.h5, ";font-weight:", typography.fontWeights.regular, ";");

var H6 = _styled("h6", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a819"
} : {
  target: "e1yuh3a819",
  label: "H6"
})(headerStyles, ";font-size:", typography.fontSizes.h6, ";font-weight:", typography.fontWeights.regular, ";line-height:1.4;");

var ThematicBreak = _styled("hr", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a818"
} : {
  target: "e1yuh3a818",
  label: "ThematicBreak"
})(process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "eivff4",
  styles: "display:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});

var Ul = _styled("ul", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a817"
} : {
  target: "e1yuh3a817",
  label: "Ul"
})("padding-left:", dimensions.spacings.xl, ";list-style-type:disc;>*+*{margin-top:", dimensions.spacings.s, ";}");

var Ol = _styled("ol", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a816"
} : {
  target: "e1yuh3a816",
  label: "Ol"
})("padding-left:", dimensions.spacings.xl, ";>*+*{margin-top:", dimensions.spacings.s, ";}");

var Dl = _styled("dl", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a815"
} : {
  target: "e1yuh3a815",
  label: "Dl"
})(">*+dt{margin:", dimensions.spacings.s, " 0 0;}>*+dd{margin:", dimensions.spacings.xs, " 0 0;}");

var Dt = _styled("dt", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a814"
} : {
  target: "e1yuh3a814",
  label: "Dt"
})("color:", colors.light.textSecondary, ";");
/*
The "container" styles have to be applied to containers that render markdown inside a surrounding
visual box like a blockquote, notification box, card, or Subtitle.
Heading margins are not set here because headings can and should not be used inside such containers.
*/


var containerStyles = function containerStyles() {
  return /*#__PURE__*/css(">*+*{margin-top:", dimensions.spacings.m, ";}>*+", Ul, ",>*+", Ol, ",>*+", Dl, "{margin-top:", dimensions.spacings.s, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:containerStyles;"));
};

var Dd = _styled("dd", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a813"
} : {
  target: "e1yuh3a813",
  label: "Dd"
})(containerStyles, " padding:0 0 0 ", dimensions.spacings.l, ";>*+*{margin:", dimensions.spacings.s, " 0;}");

var Li = _styled("li", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a812"
} : {
  target: "e1yuh3a812",
  label: "Li"
})(containerStyles, ";line-height:1.46;>ul,>ol{margin:", dimensions.spacings.s, " 0 ", dimensions.spacings.m, ";}>ul{list-style-type:circle;}");

var Blockquote = _styled("blockquote", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a811"
} : {
  target: "e1yuh3a811",
  label: "Blockquote"
})(containerStyles, ";background-color:", colors.light.surfaceQuote, ";border-left:1px solid ", colors.light.borderHighlight, ";border-radius:0 ", tokens.borderRadiusForBlockquote, " ", tokens.borderRadiusForBlockquote, " 0;color:", colors.light.textFaded, ";font-size:", typography.fontSizes.small, ";padding:", dimensions.spacings.xs, " ", dimensions.spacings.s, ";");

var Table$1 = _styled("table", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a810"
} : {
  target: "e1yuh3a810",
  label: "Table"
})("width:100%;border:1px solid ", colors.light.borderPrimary, ";border-top:2px solid ", colors.light.borderPrimary, ";border-collapse:collapse;font-size:", typography.fontSizes.body, ";margin:0;tbody{border-top:2px solid ", colors.light.borderPrimary, ";}thead tr{background:", colors.light.surfacePrimary, "!important;}@media screen and (", dimensions.viewports.mobile, "){display:block;tbody{display:block;}thead{display:block;}thead tr{position:absolute;top:-9999px;left:-9999px;}", function (props) {
  var _context, _context2;

  var tableHeaders = _findInstanceProperty(_context = React.Children.toArray(props.children)).call(_context, function (elem) {
    return reactIs.isElement(elem) && (elem.type === 'thead' || elem.props.mdxType === 'thead');
  });

  if (!tableHeaders) return null;
  var rowHeaders = reactIs.isElement(tableHeaders) && tableHeaders.props.children;
  var rowHeadersChildren = _Array$isArray(rowHeaders) ? rowHeaders : rowHeaders.props.children;
  return _reduceInstanceProperty(_context2 = React.Children.toArray(rowHeadersChildren)).call(_context2, function (styles, elem, index) {
    var _context3, _context4;

    return _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "\n        ".concat(styles, "\n        td:nth-of-type(")).call(_context4, index + 1, ")::before { content: \"")).call(_context3, reactIs.isElement(elem) && elem.props.children, "\"; }\n      ");
  }, '');
}, ";}");

var TableRow = _styled("tr", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a89"
} : {
  target: "e1yuh3a89",
  label: "TableRow"
})("&:nth-of-type(odd){background:", colors.light.surfaceSecondary1, ";}&:nth-of-type(even){background:", colors.light.surfacePrimary, ";}>*+*{border-left:1px solid ", colors.light.borderPrimary, ";}@media screen and (", dimensions.viewports.mobile, "){display:block;border:1px solid ", colors.light.borderPrimary, ";}");

var TableCell = _styled("td", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a88"
} : {
  target: "e1yuh3a88",
  label: "TableCell"
})(containerStyles, ";border-bottom:1px solid ", colors.light.borderPrimary, ";font-size:", typography.fontSizes.small, ";padding:", dimensions.spacings.s, ";white-space:pre-wrap;vertical-align:top;text-align:", function (props) {
  return props.align || 'left';
}, ";@media screen and (", dimensions.viewports.mobile, "){display:block;border:none;border-bottom:1px solid ", colors.light.borderPrimary, ";::before{display:flex;font-weight:", typography.fontWeights.bold, ";}}");

var TableHeader = _styled("th", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a87"
} : {
  target: "e1yuh3a87",
  label: "TableHeader"
})(containerStyles, ";font-size:", typography.fontSizes.small, ";padding:", dimensions.spacings.s, ";text-align:left;@media screen and (", dimensions.viewports.mobile, "){display:block;}");

var InlineCode = _styled("code", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a86"
} : {
  target: "e1yuh3a86",
  label: "InlineCode"
})("background-color:", colors.light.surfaceInlineCode, ";border:1px solid ", colors.light.borderSecondary, ";border-radius:", dimensions.spacings.xs, ";color:", colors.light.textCode, ";font-family:", typography.fontFamilies.code, ";font-size:", typography.fontSizes.small, ";padding:0 ", dimensions.spacings.xs, ";");

var Em = _styled("em", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a85"
} : {
  target: "e1yuh3a85",
  label: "Em"
})();

var Strong = _styled("strong", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a84"
} : {
  target: "e1yuh3a84",
  label: "Strong"
})();

var Delete = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a83"
} : {
  target: "e1yuh3a83",
  label: "Delete"
})(process.env.NODE_ENV === "production" ? {
  name: "1rcj98u",
  styles: "text-decoration:line-through"
} : {
  name: "1rcj98u",
  styles: "text-decoration:line-through",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});

var Hr = /*#__PURE__*/_styled(ThematicBreak, process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a82"
} : {
  target: "e1yuh3a82",
  label: "Hr"
})();

var TypographyPage = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a81"
} : {
  target: "e1yuh3a81",
  label: "TypographyPage"
})("font-family:", typography.fontFamilies.primary, ";font-size:", typography.fontSizes.body, ";font-weight:", typography.fontWeights.regular, ";line-height:1.5;section>*+*{margin-top:", dimensions.spacings.m, ";}section:first-of-type>*:first-child{margin-top:0!important;}section>", H2, "+*,section>", H3, "+*,section>", H4, "+*,section>", H5, "+*,section>", H6, "+*{margin-top:", dimensions.spacings.s, ";}.section-h4,.section-h5,.section-h6,.section-h7{padding:0 0 0 ", dimensions.spacings.l, ";}section>", H2, "{margin:", dimensions.spacings.huge, " 0 ", dimensions.spacings.m, ";}section>", H3, "{margin:", dimensions.spacings.big, " 0 0;}section>", H4, "{margin:", dimensions.spacings.xl, " 0 0;}section>", H5, "{margin:", dimensions.spacings.xl, " 0 0;}section>", H6, "{margin:", dimensions.spacings.m, " 0 ", dimensions.spacings.s, ";}section>", Blockquote, "{margin:", dimensions.spacings.l, " ", dimensions.spacings.xxl, ";}section>", Ul, ",section>", Ol, ",section>", Dl, "{margin-top:", dimensions.spacings.s, ";}");

var TypographyContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a80"
} : {
  target: "e1yuh3a80",
  label: "TypographyContainer"
})(containerStyles, ";");
/* eslint-disable react/display-name */
// eslint-disable-next-line @typescript-eslint/no-explicit-any


var withAnchorLink = function withAnchorLink(Component) {
  return function (props) {
    return jsx(Component, _extends({}, props, {
      css: /*#__PURE__*/css("display:flex;align-items:baseline;:hover{[data-link-type='anchor-link']{svg{*{fill:", colors.light.linkNavigation, ";}}}}>*+*{margin:0 0 0 ", dimensions.spacings.s, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:withAnchorLink;"))
    }), jsx("span", null, props.children), jsx("a", {
      href: "#".concat(props.id),
      "data-link-type": "anchor-link"
    }, jsx(SvgRibbon, null)));
  };
};

var markdown = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TypographyPage: TypographyPage,
  TypographyContainer: TypographyContainer,
  Paragraph: Paragraph,
  H1: H1,
  H2: H2,
  H3: H3,
  H4: H4,
  H5: H5,
  H6: H6,
  ThematicBreak: ThematicBreak,
  Blockquote: Blockquote,
  Ul: Ul,
  Ol: Ol,
  Li: Li,
  Dl: Dl,
  Dt: Dt,
  Dd: Dd,
  Table: Table$1,
  TableRow: TableRow,
  TableCell: TableCell,
  TableHeader: TableHeader,
  InlineCode: InlineCode,
  CodeBlock: CodeBlockMarkdownWrapper,
  Em: Em,
  Strong: Strong,
  Delete: Delete,
  Hr: Hr,
  withAnchorLink: withAnchorLink
});

var getIconByType = function getIconByType(type) {
  switch (type) {
    case 'warning':
      return WarningIcon;

    case 'error':
      return ErrorIcon;

    default:
      return InformationIcon;
  }
};

var getIconColorByType = function getIconColorByType(type) {
  switch (type) {
    case 'warning':
      return 'warning';

    case 'error':
      return 'error';

    default:
      return 'info';
  }
};

var Container = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ezkukxj0"
} : {
  target: "ezkukxj0",
  label: "Container"
})("background-color:", function (props) {
  switch (props.type) {
    case 'warning':
      return colors.light.surfaceWarning;

    case 'error':
      return colors.light.surfaceError;

    default:
      return colors.light.surfaceInfo;
  }
}, ";border:1px solid ", function (props) {
  switch (props.type) {
    case 'warning':
      return colors.light.textWarning;

    case 'error':
      return colors.light.textError;

    default:
      return colors.light.textInfo;
  }
}, ";border-radius:", tokens.borderRadiusForContentNotification, ";padding:", dimensions.spacings.m, ";");

var ContentNotification = function ContentNotification(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'info' : _ref$type,
      children = _ref.children;
  var Icon = getIconByType(type);
  var iconColor = getIconColorByType(type);
  return jsx(Container, {
    type: type
  }, jsx(SpacingsInline, {
    scale: "s",
    alignItems: "flex-start"
  }, jsx("div", null, jsx(Icon, {
    color: iconColor
  })), jsx(TypographyContainer, null, children)));
};

ContentNotification.propTypes = process.env.NODE_ENV !== "production" ? {
  type: _pt.oneOf(['error', 'warning', 'info']),
  children: _pt.node
} : {};

var Info = function Info(props) {
  return jsx(ContentNotification, _extends({}, props, {
    type: "info"
  }));
};

Info.propTypes = process.env.NODE_ENV !== "production" ? {
  type: _pt.oneOf(['error', 'warning', 'info']),
  children: _pt.node
} : {};

var Error$1 = function Error(props) {
  return jsx(ContentNotification, _extends({}, props, {
    type: "error"
  }));
};

Error$1.propTypes = process.env.NODE_ENV !== "production" ? {
  type: _pt.oneOf(['error', 'warning', 'info']),
  children: _pt.node
} : {};

var Warning = function Warning(props) {
  return jsx(ContentNotification, _extends({}, props, {
    type: "warning"
  }));
};

Warning.propTypes = process.env.NODE_ENV !== "production" ? {
  type: _pt.oneOf(['error', 'warning', 'info']),
  children: _pt.node
} : {};
var ContentNotifications = {
  Info: Info,
  Error: Error$1,
  Warning: Warning
};
var isoDateRegex = /^\d{4}-\d{2}-\d{2}$/; // if the date does not contain timezone, JS Date() is fine

var parseIsoDate = function parseIsoDate(dateString) {
  // as an extra safety net enforce UTC midnight
  var UTCDateString = dateString + 'T00:00:00.000Z';
  var date = new Date(UTCDateString);
  return !isNaN(date.valueOf()) && isoDateRegex.test(dateString) ? date : false;
}; // Canada has adopted ISO-8601 so it's used as a replacement for the missing
// explicit ISO format support in Javascript Intl


var IsoDateFormat = new Intl.DateTimeFormat('en-CA', {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric'
}); // For docs content we have adopted the British style "4 December 1970" format.

var DocsDateFormat = new Intl.DateTimeFormat('en-GB', {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
}); // if you have to parse such a "docs" date, you likely have a different root problem,
// formatted dates should never have to be parsed.
// Worst case use Luxon. Do not use moment.js any more. It's unmaintained and too large.

var Link$1 = _styled("a", process.env.NODE_ENV === "production" ? {
  target: "ecrcgas0"
} : {
  target: "ecrcgas0",
  label: "Link"
})("&,>code{color:", colors.light.link, ";:active,:focus,:hover{color:", colors.light.linkHover, ";}}");

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Table = _styled("table", process.env.NODE_ENV === "production" ? {
  target: "e1rq8nl71"
} : {
  target: "e1rq8nl71",
  label: "Table"
})("width:100%;border-radius:", tokens.borderRadiusForRssFeedTable, ";box-shadow:", tokens.shadowForRssFeedTable, ";tbody{tr{td{padding:", dimensions.spacings.m, ";:first-of-type{color:", colors.light.linkHover, ";}}:not(:first-of-type){border-top:1px solid ", colors.light.borderPrimary, ";}}}");

var DateWrapper = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1rq8nl70"
} : {
  target: "e1rq8nl70",
  label: "DateWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1bmnxg7",
  styles: "white-space:nowrap"
} : {
  name: "1bmnxg7",
  styles: "white-space:nowrap",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});

var _ref$1 = process.env.NODE_ENV === "production" ? {
  name: "g65o95",
  styles: "text-decoration:none"
} : {
  name: "1odge61-RssFeedTable",
  styles: "text-decoration:none;label:RssFeedTable;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "g65o95",
  styles: "text-decoration:none"
} : {
  name: "1odge61-RssFeedTable",
  styles: "text-decoration:none;label:RssFeedTable;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};

var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "1bmnxg7",
  styles: "white-space:nowrap"
} : {
  name: "o3n55d-RssFeedTable",
  styles: "white-space:nowrap;label:RssFeedTable;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};

var RssFeedTable = function RssFeedTable(props) {
  var _context;

  if (!props.data) {
    var message = 'Must pass data to RssFeedTable component.';

    if (process.env.NODE_ENV !== 'production') {
      return jsx(ContentNotifications.Error, null, message);
    }

    throw new Error(message);
  }

  return jsx("div", null, jsx(Table, {
    "data-table-name": "rss-feed"
  }, jsx("tbody", null, _mapInstanceProperty(_context = props.data).call(_context, function (item, index) {
    var _context2;

    return jsx("tr", {
      key: _concatInstanceProperty(_context2 = "".concat(item.title)).call(_context2, index)
    }, jsx("td", {
      css: _ref3
    }, jsx(DateWrapper, null, jsx(Link$1, {
      href: item.link,
      css: _ref2
    }, DocsDateFormat.format(new Date(item.pubDate))))), props.hasMultipleSources ? jsx("td", {
      css: /*#__PURE__*/css("white-space:nowrap;padding-left:", dimensions.spacings.l, "!important;" + (process.env.NODE_ENV === "production" ? "" : ";label:RssFeedTable;"))
    }, jsx(Link$1, {
      href: item.releaseNoteUrl,
      css: _ref$1
    }, item.feedName)) : null, jsx("td", null, item.title));
  }))));
};

RssFeedTable.propTypes = process.env.NODE_ENV !== "production" ? {
  data: _pt.array.isRequired,
  hasMultipleSources: _pt.bool.isRequired
} : {};

function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
      return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var _context11, _context12;

    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? _forEachInstanceProperty(_context11 = ownKeys(Object(source), !0)).call(_context11, function (key) {
      _defineProperty(target, key, source[key]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context12 = ownKeys(Object(source))).call(_context12, function (key) {
      _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var firstDataForQuery = function firstDataForQuery(node, query) {
  var _firstChild$textConte;

  var firstChild = node.querySelector(query);
  return firstChild === null || firstChild === void 0 ? void 0 : (_firstChild$textConte = firstChild.textContent) === null || _firstChild$textConte === void 0 ? void 0 : _trimInstanceProperty(_firstChild$textConte).call(_firstChild$textConte);
}; // Inspired by https://css-tricks.com/how-to-fetch-and-parse-rss-feeds-in-javascript/


var parseRssFeed = function parseRssFeed(rssString) {
  var _context;

  var documentFragment = new window.DOMParser().parseFromString(rssString, 'text/xml');
  var feedTitle = firstDataForQuery(documentFragment, 'title') || '';

  var items = _mapInstanceProperty(_context = _Array$from(documentFragment.querySelectorAll('item'))).call(_context, function (el) {
    var title = firstDataForQuery(el, 'title') || '';
    var description = firstDataForQuery(el, 'description') || '';
    var link = firstDataForQuery(el, 'link') || '';
    var pubDate = firstDataForQuery(el, 'pubDate') || '';
    return {
      title: title,
      description: description,
      link: link,
      pubDate: pubDate
    };
  });

  return {
    feedTitle: feedTitle,
    items: items
  };
};

var fetchRssFeed = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var response, rawBody;
    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(url);

          case 2:
            response = _context2.sent;
            _context2.next = 5;
            return response.text();

          case 5:
            rawBody = _context2.sent;
            return _context2.abrupt("return", parseRssFeed(rawBody));

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));

  return function fetchRssFeed(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetcher = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _len,
        args,
        _key,
        promises,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            for (_len = _args3.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _args3[_key];
            }

            promises = _mapInstanceProperty(args).call(args, /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url) {
                var _context3;

                var releaseNoteUrl, feedData, feedName, refactoredData;
                return _regeneratorRuntime.wrap(function _callee2$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        releaseNoteUrl = url.replace(/\/feed.xml$/, '');
                        _context4.next = 3;
                        return fetchRssFeed(url);

                      case 3:
                        feedData = _context4.sent;
                        feedName = feedData.feedTitle.replace(/^commercetools (.*) Release Notes$/, '$1');
                        refactoredData = _mapInstanceProperty(_context3 = feedData.items).call(_context3, function (item) {
                          return _objectSpread(_objectSpread({}, item), {}, {
                            feedName: feedName,
                            releaseNoteUrl: releaseNoteUrl
                          });
                        });
                        return _context4.abrupt("return", refactoredData);

                      case 7:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x2) {
                return _ref3.apply(this, arguments);
              };
            }());
            return _context5.abrupt("return", _Promise.all(promises));

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee3);
  }));

  return function fetcher() {
    return _ref2.apply(this, arguments);
  };
}();

var transformData = function transformData(data) {
  var _context6, _context8, _context9; // First, we need to get the oldest release note from each feed,
  // which is always the last entry of the list.


  var lastEntryOfList = _reduceInstanceProperty(_context6 = _reduceInstanceProperty(data).call(data, function (list, feed) {
    var _context7;

    return _concatInstanceProperty(_context7 = []).call(_context7, _toConsumableArray(list), [feed[feed.length - 1]]);
  }, []) // After that, we need to compare the oldest release dates from each feed
  // to get the newest of them. This will be our last entry in the list.
  ).call(_context6, function (currentOldestEntry, entry, index) {
    if (!entry || index === 0) {
      return entry;
    }

    return new Date(entry.pubDate) > new Date(currentOldestEntry.pubDate) ? entry : currentOldestEntry;
  }, {}); // After finding out the last entry in the list, we reduce the list
  // to all entries that have a newer date than our last entry.


  var tableData = _sortInstanceProperty(_context8 = _reduceInstanceProperty(_context9 = _flatInstanceProperty(data).call(data)).call(_context9, function (list, entry) {
    var _context10;

    return new Date(entry.pubDate) >= new Date(lastEntryOfList.pubDate) ? _concatInstanceProperty(_context10 = []).call(_context10, _toConsumableArray(list), [entry]) : _toConsumableArray(list);
  }, []) // Now we sort the release notes by their release date.
  ).call(_context8, function (dateOne, dateTwo) {
    return new Date(dateTwo.pubDate).getTime() - new Date(dateOne.pubDate).getTime();
  });

  return tableData;
};

var RssFeeds = function RssFeeds(props) {
  if (!props.dataSources) {
    var message = "Missing prop \"dataSources\" for the \"<RssFeeds>\" component.";

    if (process.env.NODE_ENV !== 'production') {
      return jsx(ContentNotifications.Error, null, message);
    }

    throw new Error(message);
  } // eslint-disable-next-line react-hooks/rules-of-hooks


  var _useSWR = useSWR(props.dataSources, fetcher),
      data = _useSWR.data,
      error = _useSWR.error;

  if (error) {
    console.log(error);

    var _message = jsx(ContentNotifications.Error, null, "Error Loading Data from ", props.dataSources);

    return _message;
  }

  if (data) {
    return jsx(RssFeedTable, {
      hasMultipleSources: props.dataSources.length > 1,
      data: transformData(data)
    });
  }

  return jsx(LoadingSpinner, {
    scale: "s"
  }, 'Loading feeds');
};

RssFeeds.propTypes = process.env.NODE_ENV !== "production" ? {
  dataSources: _pt.arrayOf(_pt.string).isRequired
} : {};

var Globals = function Globals() {
  return jsx(Global, {
    styles: /*#__PURE__*/css("html,body{padding:0;margin:0;height:100vh;color:", colors.light.textPrimary, ";font-family:", typography.fontFamilies.primary, ";font-size:", typography.rootFontSize, ";font-weight:", typography.fontWeights.regular, ";}iframe{border:0;outline:0;padding:0;margin:0;}[data-reach-skip-link]:focus{z-index:100;}.gatsby-resp-image-wrapper{background-color:", colors.light.surfaceSecondary1, ";border-radius:", tokens.borderRadiusForImageFrame, ";margin:", dimensions.spacings.m, " 0 ", dimensions.spacings.xxl, ";padding:", dimensions.spacings.s, ";}.gatsby-resp-image-figure{background-color:", colors.light.surfaceSecondary1, ";border-radius:", tokens.borderRadiusForImageFrame, ";margin:0;padding:", dimensions.spacings.s, ";}.gatsby-resp-image-link{text-decoration:none;}.gatsby-resp-image-image{background-color:", colors.light.surfacePrimary, ";box-shadow:none!important;width:calc(100% - ", dimensions.spacings.s, " * 2)!important;height:auto!important;margin:", dimensions.spacings.s, "!important;}.gatsby-resp-image-figure .gatsby-resp-image-wrapper{background-color:unset;border-radius:unset;margin:unset;padding:unset;}.gatsby-resp-image-figure .gatsby-resp-image-image{width:100%!important;height:unset!important;margin:unset!important;}.gatsby-resp-image-figcaption{color:", colors.light.textSecondary, ";font-size:", typography.fontSizes.small, ";margin:", dimensions.spacings.xs, " 0 0;}code,kbd,samp,pre{font-family:", typography.fontFamilies.code, ",'Menlo','Monaco','Consolas','Liberation Mono','Courier New',monospace;font-size:", typography.fontSizes.small, ";}b,strong{font-weight:", typography.fontWeights.bold, ";}small{font-size:", typography.fontSizes.small, ";}sub,sup{font-size:", typography.fontSizes.extraSmall, ";line-height:0;position:relative;}ul,ol{list-style-position:outside;padding-inline-start:0;-webkit-padding-start:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:Globals;"))
  });
};

var LinkContainer = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "eoxdbxa2"
} : {
  target: "eoxdbxa2",
  label: "LinkContainer"
})("padding:0 ", dimensions.spacings.m, ";height:100%;display:flex;flex-direction:column;justify-content:center;"); // This is a normal HTML link as we need to force a redirect to the root domain


var Link = _styled("a", process.env.NODE_ENV === "production" ? {
  target: "eoxdbxa1"
} : {
  target: "eoxdbxa1",
  label: "Link"
})("color:", colors.light.textPrimary, ";text-decoration:none;white-space:nowrap;cursor:pointer;display:block;width:100%;");

var Title = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "eoxdbxa0"
} : {
  target: "eoxdbxa0",
  label: "Title"
})("display:none;font-size:", typography.fontSizes.body, ";@media screen and (", dimensions.viewports.laptop, "){display:block;}@media screen and (", dimensions.viewports.desktop, "){font-size:", typography.fontSizes.h4, ";}");

var LogoButton = function LogoButton() {
  return jsx(Link, {
    href: "/"
  }, jsx(LinkContainer, null, jsx(SpacingsInline, {
    scale: "m",
    alignItems: "center"
  }, jsx(SvgLogo, {
    height: 32
  }), jsx(Title, null, 'Documentation'))));
};

LogoButton.displayName = 'LogoButton';

var MediaQuery = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e65a6d60"
} : {
  target: "e65a6d60",
  label: "MediaQuery"
})(function (props) {
  switch (props.forViewport) {
    case 'mobile':
      return /*#__PURE__*/css("display:", props.hideIfMatch ? 'block' : 'none', ";@media screen and (", dimensions.viewports.mobile, "){display:", props.hideIfMatch ? 'none' : 'block', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:MediaQuery;"));

    case 'tablet':
      return /*#__PURE__*/css("display:", props.hideIfMatch ? 'block' : 'none', ";@media screen and (", dimensions.viewports.tablet, "){display:", props.hideIfMatch ? 'none' : 'block', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:MediaQuery;"));

    case 'largeTablet':
      return /*#__PURE__*/css("display:", props.hideIfMatch ? 'block' : 'none', ";@media screen and (", dimensions.viewports.largeTablet, "){display:", props.hideIfMatch ? 'none' : 'block', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:MediaQuery;"));

    case 'laptop':
      return /*#__PURE__*/css("display:", props.hideIfMatch ? 'block' : 'none', ";@media screen and (", dimensions.viewports.laptop, "){display:", props.hideIfMatch ? 'none' : 'block', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:MediaQuery;"));

    default:
      return /*#__PURE__*/css(process.env.NODE_ENV === "production" ? "" : ";label:MediaQuery;");
  }
}, ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var _ref = process.env.NODE_ENV === "production" ? {
  name: "iskwe5",
  styles: "html,body,#___gatsby,#gatsby-focus-wrapper{height:100%;width:100%;}html,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video{margin:0;padding:0;border:0;font-size:100%;vertical-align:baseline;}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block;}blockquote,q{quotes:none;}blockquote::before,blockquote::after,q::before,q::after{content:'';}table{border-collapse:collapse;border-spacing:0;}body{margin:0;padding:0;border:0;font-style:normal;font-variant:normal;font-stretch:normal;text-align:left;vertical-align:baseline;text-rendering:optimizelegibility;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:rgba(black 0);}[tabindex='-1']:focus:not(:focus-visible){outline:0!important;}img{max-width:100%;}svg{overflow:hidden;vertical-align:middle;}caption{text-align:center;caption-side:bottom;}hr{height:0;overflow:visible;}abbr[title]{border-bottom:none;text-decoration:underline dotted;}sub{bottom:-0.25em;}sup{top:-0.5em;}label{display:inline-block;}button{border-radius:0;}button,input{overflow:visible;}button:focus{outline:1px dotted;}button,select{text-transform:none;}select{word-wrap:normal;}button,[type='button'],[type='reset'],[type='submit']{-webkit-appearance:button;}input[type='radio'],input[type='checkbox']{box-sizing:border-box;}textarea{overflow:auto;resize:vertical;}fieldset{min-width:0;}legend{line-height:inherit;color:inherit;white-space:normal;}[type='number']::-webkit-inner-spin-button,[type='number']::-webkit-outer-spin-button{height:auto;}[type='search'],[type='search']::-webkit-search-decoration{-webkit-appearance:none;}::-webkit-file-upload-button{-webkit-appearance:button;}output{display:inline-block;}summary{display:list-item;cursor:pointer;}template{display:none;}[hidden]{display:none!important;}"
} : {
  name: "q0d9u1-Reset",
  styles: "html,body,#___gatsby,#gatsby-focus-wrapper{height:100%;width:100%;}html,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video{margin:0;padding:0;border:0;font-size:100%;vertical-align:baseline;}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block;}blockquote,q{quotes:none;}blockquote::before,blockquote::after,q::before,q::after{content:'';}table{border-collapse:collapse;border-spacing:0;}body{margin:0;padding:0;border:0;font-style:normal;font-variant:normal;font-stretch:normal;text-align:left;vertical-align:baseline;text-rendering:optimizelegibility;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:rgba(black 0);}[tabindex='-1']:focus:not(:focus-visible){outline:0!important;}img{max-width:100%;}svg{overflow:hidden;vertical-align:middle;}caption{text-align:center;caption-side:bottom;}hr{height:0;overflow:visible;}abbr[title]{border-bottom:none;text-decoration:underline dotted;}sub{bottom:-0.25em;}sup{top:-0.5em;}label{display:inline-block;}button{border-radius:0;}button,input{overflow:visible;}button:focus{outline:1px dotted;}button,select{text-transform:none;}select{word-wrap:normal;}button,[type='button'],[type='reset'],[type='submit']{-webkit-appearance:button;}input[type='radio'],input[type='checkbox']{box-sizing:border-box;}textarea{overflow:auto;resize:vertical;}fieldset{min-width:0;}legend{line-height:inherit;color:inherit;white-space:normal;}[type='number']::-webkit-inner-spin-button,[type='number']::-webkit-outer-spin-button{height:auto;}[type='search'],[type='search']::-webkit-search-decoration{-webkit-appearance:none;}::-webkit-file-upload-button{-webkit-appearance:button;}output{display:inline-block;}summary{display:list-item;cursor:pointer;}template{display:none;}[hidden]{display:none!important;};label:Reset;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var Reset = function Reset() {
  return jsx(React.Fragment, null, jsx(Global, {
    styles: _ref
  }));
};

var Subtitle = /*#__PURE__*/_styled(TypographyContainer, process.env.NODE_ENV === "production" ? {
  target: "egp8w9y0"
} : {
  target: "egp8w9y0",
  label: "Subtitle"
})("font-size:", typography.fontSizes.h3, ";");

var TextSmall = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "eak6k4o0"
} : {
  target: "eak6k4o0",
  label: "TextSmall"
})("font-size:", typography.fontSizes.small, ";color:", colors.light.textSecondary, ";");

var iconSizes = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeStyle = function getSizeStyle(size) {
  var _context, _context2;

  switch (size) {
    case 'scale':
      return "\n        &:not(:root) {\n          width: 100%;\n          height: auto;\n        }\n      ";

    case 'small':
    case 'medium':
    case 'big':
      return _concatInstanceProperty(_context = "\n        width: ".concat(iconSizes[size], "px;\n        height: ")).call(_context, iconSizes[size], "px;\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(iconSizes.big, "px;\n        height: ")).call(_context2, iconSizes.big, "px;\n      ");
  }
};

var getColor = function getColor(color) {
  if (!color) return 'inherit';
  var iconColor = colors.light[color];

  if (!iconColor) {
    !color ? process.env.NODE_ENV !== "production" ? invariant(false, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : invariant(false) : void 0;
    return 'inherit';
  }

  return iconColor;
};

function createStyledIcon(Component) {
  var StyledComponent = /*#__PURE__*/_styled(Component, process.env.NODE_ENV === "production" ? {
    target: "evnivnw0"
  } : {
    target: "evnivnw0",
    label: "StyledComponent"
  })(function (props) {
    return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor(props.color), ";}", getSizeStyle(props.size), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledComponent;"));
  });

  return StyledComponent;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var SafeHTMLElement = canUseDOM ? window.HTMLElement : {};
var narrowNonBreakingSpace = "\u202F";

var useISO310NumberFormatter = function useISO310NumberFormatter() {
  var intl = useIntl();
  return useCallback(function (value) {
    var _context;

    if (typeof value !== 'number') return value;
    return _mapInstanceProperty(_context = intl.formatNumberToParts(value, {
      maximumFractionDigits: 20
    })).call(_context, function (_ref) {
      var type = _ref.type,
          value = _ref.value;
      return type === 'group' ? narrowNonBreakingSpace : value;
    }).join('');
  }, [intl]);
};

export { CodeBlock, ContentNotifications, SvgCustomApplicationSmall as CustomApplicationSmallSvgIcon, SvgCustomApplication as CustomApplicationSvgIcon, DocsDateFormat, Globals, SvgHttpApiSmall as HttpApiSmallSvgIcon, SvgHttpApi as HttpApiSvgIcon, IsoDateFormat, Link$1 as Link, LogoButton, markdown as Markdown, MediaQuery, SvgMerchantCenterSmall as MerchantCenterSmallSvgIcon, SvgMerchantCenter as MerchantCenterSvgIcon, MultiCodeBlock, SvgOpenSourceSmall as OpenSourceSmallSvgIcon, SvgOpenSource as OpenSourceSvgIcon, Reset, RssFeeds, SafeHTMLElement, Subtitle, TextSmall, SvgTutorialsSmall as TutorialsSmallSvgIcon, SvgTutorials as TutorialsSvgIcon, createStyledIcon, designSystem, parseIsoDate, useISO310NumberFormatter };